
import { useContext, useEffect, useRef, useState } from "react";
//import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import 'bootstrap/dist/css/bootstrap.css';
import { Container, Image, Tab, Tabs } from "react-bootstrap";
import {castcoTitleIcon} from "../../assets/imgs";
import SteelBarFormModel from "../../models/SteelBarFormModel";
import SpecimensModel from "../../models/SpecimensModel";
import TestReportModel from "../../models/TestReportModel";
import ImageModel from "../../models/ImageModel";
import useDeviceSize from "../../utils/useDeviceSize";
import { toast } from "react-toastify";
import api from '../../app/api/agent'
import { GlobalStateContext } from "../../store/GlobalState";
import SimpleDialog from "../../components/DialogAlertBox";
import ImgUploadBox from "../../components/applicationForm/items/ImgUploadBox";
import React from "react";
import clearEmptyFields from "../../utils/clearFields";
import SimpleDialogConfirm from "../../components/DialogConfirm";
import steelBarFormErrorMessages from "../../constants/steelBarForm/ErrorMessages.json";
//import Cookies from "js-cookie";

  const SteelBarFormEdit = () => {
    //const theme = useTheme();
    //const [email, setEmail] = useState("");
    //const [password, setPassword] = useState("");
    //const [showPassword, setShowPassword] = useState(false);
    //const [isLoading, setIsLoading] = useState(false);
    //const [error, setError] = useState<string | null>(null);
    //const dispatch = useDispatch();
    //const navigate = useNavigate();
  
    const [steelBarFormData, setSteelBarForm] = useState(new SteelBarFormModel())
    const [specimensData, setSpecimens] = useState(new SpecimensModel())
    const [testReportData, setTestReport] = useState(new TestReportModel())
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [imgData, setImg] = useState(new ImageModel())
    const [submitting, setsubmitting] = useState(false);
    const [saving, setsaving] = useState(false);

    const [validated, setValidated] = useState(false);
    const [numberOfSpecimensstate, setNumberOfSpecimensstate] = useState(1);
    const [lastNumberOfSpecimens, setLastNumberOfSpecimens] = useState(1);
    const [specimensList, setSpecimensList]: any[] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [copyAndAdd, setCopyAndAdd] = useState(false);
    const [copyAndAddList, setCopyAndAddList]: any[]  = useState([]);
    const [index, setIndex] = useState<number>();


    const [numberOfTestReportstate, setNumberOfTestReportstate] = useState(1);
    const [lastNumberOfTestReport, setLastNumberOfTestReport] = useState(1);
    const [testReportList, setTestReportList]: any[] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [copyAndAddTestReport, setCopyAndAddTestReport] = useState(false);
    const [copyAndAddTestReportList, setCopyAndAddTestReportList]: any[]  = useState([]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[SrcSignSteel, setSrcSignSteel] = useState("")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[SrcSignChemistry, setSrcSignChemistry] = useState("")
    const[SrcSign, setSrcSign] = useState("")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[SrcChop, setSrcChop] = useState("")
    const[SrcStockistCert, setSrcStockistCert] = useState<string[]>([])
    const[SrcStockistCertType, setSrcStockistCertType] = useState<string[]>([])
    const[SrcMillCert, setSrcMillCert] = useState<string[]>([])
    const[SrcMillCertType, setSrcMillCertType] = useState<string[]>([])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[type, setType] = useState("")
    const[typeSign, setTypeSign] = useState("")


    const [SteelBarForm, setSteelBarFormCustom] = useState<{ [x: string]: any } | undefined>(undefined)
    

    let numberOfSpecimens =  1;
    let numberOfTestReport =  1;

    //const[SrcidPhoto, setSrcidPhoto] = useState("")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[SrcSignature, setSrcSignature] = useState("")
    const[SrcChopNew, setSrcChopNew] = useState("")
    //const[SrcSignatureSteel, setSrcSignatureSteel] = useState("")
    //const[SrcSignatureChemistry, setSrcSignatureChemistry] = useState("")

    const submitButtonRef = useRef<HTMLButtonElement>(null);
    const saveButtonRef = useRef<HTMLButtonElement>(null);

    const [open, setOpen] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [reload, setReload] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openSuccessEdit, setOpenSuccessEdit] = useState(false);
    const [openSuccessSave, setOpenSuccessSave] = useState(false);


    const handleClickOpenSuccess = () => {
        setOpenSuccess(true);
    };

    const handleClickOpenSuccessEdit = () => {
        setOpenSuccessEdit(true);
    };

    const handleClickOpenSuccessSave = () => {
        setOpenSuccessSave(true);
    };

    const findLongestArray = (obj : object) => {
    return Object.values(obj).reduce((longest : Array<string | number>, current) => {
        return Array.isArray(current) && current.length > longest.length ? current : longest;
    }, []);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();
    const formId = searchParams.get("formId")
    const status = searchParams.get("status")


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getSrcCert = async(genre: string, IdList: string[])=>{
    try{
        
        var SrcStockistCertList: string[] = []
        var SrcStockistCertListType: string[] = []
        var SrcMillCertList: string[] = []
        var SrcMillCertListType: string[] = []
        for (const Id of IdList) {
            if(Id === ""){
                if(genre==="StockistCert"){
                    SrcStockistCertList!.push("");
                    SrcStockistCertListType!.push("");

                }else{
                    
                    SrcMillCertList!.push("");
                    SrcMillCertListType!.push("");
                }
            }else{

            await api.get(localStorage.accessToken ? `/File/${genre}/${Id}/${localStorage.getItem("accessToken")}` : `/File/${genre}/${Id}`, {
                responseType: "arraybuffer",
                withCredentials: localStorage.accessToken ? false : true,
                }).then(async (response)=>{
                        const contentType = response.headers['content-type']?.toString();
                        const data = new Uint8Array(response.data);
                        var ext = ".zip";
                        if (data.length < 2) ext = 'unknown';
                        if (data[0] == 0xFF && data[1] == 0xD8) ext = '.jpg';
                        if (data[0] == 0x89 && data[1] == 0x50) ext = '.png';
                        if (data[0] == 0x50 && data[1] == 0x4B) ext = '.zip';
                        if (data[0] == 0x25 && data[1] == 0x50) ext = '.pdf';
                        if (contentType!.includes("pdf")){
                            //setSrc("");
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }else if(contentType!.includes("image")){
                            //setSrc("");
                            buffer = response.data;
                            blob = new Blob([buffer], {
                                type: 'image/png'
                            });
                            objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }else{
                            //setSrc("");
                            buffer = response.data;
                            blob = new Blob([buffer], {
                                type: 'application/octet-stream'
                            });
                            objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }
                    }

                )
        
            }
        }
        if(genre==="StockistCert"){
            console.log(SrcStockistCertList)
            console.log(SrcStockistCertListType)
            setSrcStockistCert(SrcStockistCertList);  
            setSrcStockistCertType(SrcStockistCertListType);  
        }else{
            console.log(SrcMillCertList)
            console.log(SrcMillCertListType)
            setSrcMillCert(SrcMillCertList);  
            setSrcMillCertType(SrcMillCertListType);  
        }
    }catch(e){
    console.log(`Error: ${e}`)
    }
    
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getSrc = async(genre: string, Id: string)=>{
        try{
            //var apiurl = "/File/GetImageFile?formId=";
            //await api.get(apiurl + formId + "&genre=" + genre, {
            await api.get(localStorage.accessToken ? `/File/${genre}/${Id}/${localStorage.getItem("accessToken")}` : `/File/${genre}/${Id}`, {
                responseType: "arraybuffer",
                withCredentials: localStorage.accessToken ? false : true,
                }).then(async (response)=>{

                    if(genre === "Steel" || genre === "Chemistry" || genre === "Sign"){
                        if(genre === "Steel"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSignSteel(base64)
                        }
                        else if(genre === "Chemistry"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSignChemistry(base64)
                        }
                        else{
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSign(base64)
                        }
                    }else{
                        const contentType = response.headers['content-type']?.toString();
                        const data = new Uint8Array(response.data);
                        var ext = "image";
                        if (data[0] == 0x25 && data[1] == 0x50) ext = 'pdf';
                        if (ext!.includes("pdf")){
                            //setSrc("");
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            setSrcChop(objectURL);
                            setType(ext!)
                        }else{
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcChop(base64)
                            setType(ext!)
                        }
                        /* else if (type === "Photo Not Found"){
                            //setSrc("");
                        }
                        else if (type !== "pdf"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcChop(base64)
                        }else{
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            setSrcChop(objectURL);
                        } */
                    }

                    
            })
            }catch(e){
            console.log(`Error: ${e}`)
            }
        
        }

    /* const getDetailImg = async(formId: string)=>{
            await api.get(`/SteelBarForm?formId=${formId}`,{withCredentials: true}).then((response)=>{
                if (response.status !== 404){
                    setSteelBarFormCustom(response.data)
                }else{
                }
            })
        }
     */

    const getDetail = async(formId: string)=>{
        await api.get(`/SteelBarForm?formId=${formId}`,{withCredentials: true}).then((response)=>{

            

            if (response.status !== 404){
                setSteelBarFormCustom(response.data)
                setSteelBarForm({...steelBarFormData
                    ,isOtherTestingAccordance: response.data["testMethodOther"] !== null && response.data["testMethodOther"] !== ""
                    ,contractNO: response.data["contractNum"]
                    ,customer: response.data["customer"]
                    ,project: response.data["project"]
                    ,contactPerson: response.data["contact"]
                    ,telNO: response.data["telNum"]
                    ,faxNO: response.data["faxNum"]
                    ,email: response.data["email"]
                    ,sendTo: response.data["reportTo"]
                    ,billTo: response.data["billTo"]

                    ,customerRefNO: response.data["customerRef"]
                    ,testingAccordance: response.data["testMethod"]
                    ,testingAccordanceOther: response.data["testMethodOther"]
                    ,dateDelivered: response.data["dateDeliveredToSite"] === null ? null : response.data["dateDeliveredToSite"].toString().substring(0, 10)
                    ,supplier: response.data["supplier"]
                    ,expressOrNot: response.data["expressTestService"] === null ? undefined : response.data["expressTestService"] === 0 ? false : true
                    ,expressThirtyOrFifty: response.data["expressTestService"] === null ? undefined : response.data["expressTestService"] === 1 ? "30%" : "50%"
                    ,conformity: response.data["statement"] === null ? undefined : (Number(response.data["statement"]) + 1).toString()
                    ,remark: response.data["remark"]
                })

                var idList: string[] | undefined = []
                var setNOList: number[] | undefined = []
                var batchNOList: string[] | undefined = []
                var massInBatchList: number[] | undefined = []
                var nominalSizeList: number[] | undefined = []
                var gradeList: string[] | undefined = []
                var barPatternList: string[] | undefined = []
                var customerList: string[] | undefined = []
                var customerSampleIdentityNOList: string[] | undefined = []
                var numberOfTestSpecimenTensileList: number[] | undefined = []
                var numberOfTestSpecimenBendPerformanceList: number[] | undefined = []
                var numberOfTestSpecimenBondPropertyList: number[] | undefined = []
                var numberOfTestSpecimenChemicalCompositionList: number[] | undefined = []
                var classList: string[] | undefined = []
                for(var i = 0; i < response.data["specimen"].length; i++){
                    idList[i] = response.data["specimen"][i]["id"] as string;
                    setNOList[i] = isNaN(Number(response.data["specimen"][i]["setNum"])) === true ? 0 : response.data["specimen"][i]["setNum"] as number;
                    batchNOList[i] = response.data["specimen"][i]["batchNum"] as string;
                    massInBatchList[i] = isNaN(Number(response.data["specimen"][i]["massInBatch"])) === true ? 0 : response.data["specimen"][i]["massInBatch"] as number;
                    nominalSizeList[i] = isNaN(Number(response.data["specimen"][i]["nominalSize"])) === true ? 0 : response.data["specimen"][i]["nominalSize"] as number;
                    gradeList[i] = response.data["specimen"][i]["grade"] as string;
                    barPatternList[i] = response.data["specimen"][i]["barPattern"] as string;
                    customerList[i] = response.data["specimen"][i]["customer"] as string;
                    customerSampleIdentityNOList[i] = response.data["specimen"][i]["customerSampleId"] as string;
                    numberOfTestSpecimenTensileList[i] = isNaN(Number(response.data["specimen"][i]["tensile"])) === true ? 0 : response.data["specimen"][i]["tensile"] as number;
                    numberOfTestSpecimenBendPerformanceList[i] = isNaN(Number(response.data["specimen"][i]["bendPerformance"])) === true ? 0 : response.data["specimen"][i]["bendPerformance"] as number;
                    numberOfTestSpecimenBondPropertyList[i] = isNaN(Number(response.data["specimen"][i]["bondPorperty"])) === true ? 0 : response.data["specimen"][i]["bondPorperty"] as number;
                    numberOfTestSpecimenChemicalCompositionList[i] = isNaN(Number(response.data["specimen"][i]["chemicalComposition"])) === true ? 0 : response.data["specimen"][i]["chemicalComposition"] as number;
                    if(response.data["specimen"][i]["class"] === null){
                        continue
                    }else{
                        classList[i] = response.data["specimen"][i]["class"] as string;
                    }
                }
                
                setSpecimens({...specimensData
                    , id: idList
                    , setNO: setNOList
                    , batchNO: batchNOList
                    , massInBatch: massInBatchList
                    , nominalSize: nominalSizeList
                    , grade: gradeList
                    , barPattern: barPatternList
                    , customer: customerList
                    , customerSampleIdentityNO: customerSampleIdentityNOList
                    , numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList
                    , numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList
                    , numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList
                    , numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList
                    , class: classList
                })
                if(response.data["specimen"].length !== 0){
                    setNumberOfSpecimensstate(response.data["specimen"].length > 0 ? response.data["specimen"].length ?? 1 : 1)
                    setLastNumberOfSpecimens((response.data["specimen"].length ?? 2) - 1)
                    var specimenlist = []
                    var copyandaddlist = []

                    for(i = 2; i <= response.data["specimen"].length; i++){
                        specimenlist.push(<></>);
                        copyandaddlist.push(false);
                    }
                    if(specimenlist.length !== 0){
                        setSpecimensList(...specimensList, specimenlist)
                        setCopyAndAddList(...copyAndAddList, copyandaddlist)
                    }
                }

                idList = []
                setNOList = []
                var deliveryNoteNOList: string[] | undefined = []
                var stockistCertNOList: string[] | undefined = []
                var lotNOList: string[] | undefined = []
                var millCertNOList: string[] | undefined = []
                var heatNOList: string[] | undefined = []
                for(i = 0; i < response.data["additionInfo"].length; i++){
                    if(response.data["additionInfo"][i]["id"] === null){
                        idList[i] = "";
                    }else{
                        idList[i] = response.data["additionInfo"][i]["id"] as string;
                    }

                    if(response.data["additionInfo"][i]["setNum"] === null){
                        setNOList[i] = i + 1;
                    }else{
                        setNOList[i] = response.data["additionInfo"][i]["setNum"] as number;
                    }

                    if(response.data["additionInfo"][i]["deliveryNoteNum"] === null){
                        deliveryNoteNOList[i] = "";
                    }else{
                        deliveryNoteNOList[i] = response.data["additionInfo"][i]["deliveryNoteNum"] as string;
                    }

                    if(response.data["additionInfo"][i]["stockistCertNum"] === null){
                        stockistCertNOList[i] = "";
                    }else{
                        stockistCertNOList[i] = response.data["additionInfo"][i]["stockistCertNum"] as string;
                    }

                    if(response.data["additionInfo"][i]["lotNum"] === null){
                        lotNOList[i] = "";
                    }else{
                        lotNOList[i] = response.data["additionInfo"][i]["lotNum"] as string;
                    }

                    if(response.data["additionInfo"][i]["millCertNum"] === null){
                        millCertNOList[i] = "";
                    }else{
                        millCertNOList[i] = response.data["additionInfo"][i]["millCertNum"] as string;
                    }

                    if(response.data["additionInfo"][i]["heatNum"] === null){
                        heatNOList[i] = "";
                    }else{
                        heatNOList[i] = response.data["additionInfo"][i]["heatNum"] as string;
                    }

                }

                setTestReport({...testReportData
                    , id: idList
                    , setNO: setNOList
                    , deliveryNoteNO: deliveryNoteNOList
                    , stockistCertNO: stockistCertNOList
                    , lotNO: lotNOList
                    , millCertNO: millCertNOList
                    , heatNO: heatNOList
                })
                if(response.data["additionInfo"].length !== 0){
                    setNumberOfTestReportstate(response.data["additionInfo"].length > 0 ? response.data["additionInfo"].length ?? 1 : 1)
                    setLastNumberOfTestReport((response.data["additionInfo"].length ?? 2) - 1)
                    var testreportslist = []
                    var copyandaddtestreportlist = []
                    for(i = 2; i <= response.data["additionInfo"].length; i++){
                        testreportslist.push(<></>);
                        copyandaddtestreportlist.push(false);
                    }
                    if(testreportslist.length !== 0){
                        setTestReportList(...testReportList, testreportslist)
                        setCopyAndAddTestReportList(...copyAndAddTestReportList, copyandaddtestreportlist)
                    }
                }
                setReload(true);
            }else{
            }
        })
    }

    useEffect(()=>{
            if(formId){
                getDetail(formId)
                localStorage.setItem('formId', formId)
            }
            /* if(formId && localStorage.getItem('formId') !== null && formId !== localStorage.getItem('formId')){
                getDetail(formId)
                localStorage.setItem('formId', formId)
            }
            else if(localStorage.getItem('steelBarFormData') !== null){
                setSteelBarForm(JSON.parse(localStorage.getItem('steelBarFormData')!))
                getDetailImg(formId!)
            }else{
                if(formId){
                    getDetail(formId)
                    localStorage.setItem('formId', formId)
                }
            } */
            /* if(localStorage.getItem('specimensDataEdit') !== null){
                setSpecimens(JSON.parse(localStorage.getItem('specimensDataEdit')!))
                setNumberOfSpecimensstate(findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length > 0 ? findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length ?? 1 : 1)
                setLastNumberOfSpecimens((findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length ?? 2) - 1)
                var specimenlist = []
                for(var i = 3; i <= findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length; i++){
                    specimenlist.push(<></>);
                }
                if(specimenlist.length !== 0){
                    setSpecimensList(...specimensList, specimenlist)
                }
            }else{
                var numberOfTestSpecimenTensileList = specimensData.numberOfTestSpecimenTensile ? specimensData.numberOfTestSpecimenTensile : []
                numberOfTestSpecimenTensileList![0] = 0

                var numberOfTestSpecimenBendPerformanceList = specimensData.numberOfTestSpecimenBendPerformance ? specimensData.numberOfTestSpecimenBendPerformance : []
                numberOfTestSpecimenBendPerformanceList![0] = 0

                var numberOfTestSpecimenBondPropertyList = specimensData.numberOfTestSpecimenBondProperty ? specimensData.numberOfTestSpecimenBondProperty : []
                numberOfTestSpecimenBondPropertyList![0] = 0

                var numberOfTestSpecimenChemicalCompositionList = specimensData.numberOfTestSpecimenChemicalComposition ? specimensData.numberOfTestSpecimenChemicalComposition : []
                numberOfTestSpecimenChemicalCompositionList![0] = 0
                                    

                setSpecimens({...specimensData
                    
                    , numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList
                    , numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList
                    , numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList
                    , numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList
                })
            }
            if(localStorage.getItem('testReportDataEdit') !== null){
                setTestReport(JSON.parse(localStorage.getItem('testReportDataEdit')!))
                setNumberOfTestReportstate(findLongestArray(JSON.parse(localStorage.getItem('testReportDataEdit')!)).length > 0 ? findLongestArray(JSON.parse(localStorage.getItem('testReportDataEdit')!)).length ?? 1 : 1)
                setLastNumberOfTestReport((findLongestArray(JSON.parse(localStorage.getItem('testReportDataEdit')!)).length ?? 2) - 1)
                var testreportslist = []
                for(i = 3; i <= findLongestArray(JSON.parse(localStorage.getItem('testReportDataEdit')!)).length; i++){
                    testreportslist.push(<></>);
                }
                if(testreportslist.length !== 0){
                    setTestReportList(...testReportList, testreportslist)
                }
            } */
            // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    useEffect(()=>{
            
                if(SteelBarForm && SrcSign === ""){
                    //getSrc("Chop", SteelBarForm["chop"])
                    if(SteelBarForm["signature"])
                        getSrc("Sign", SteelBarForm["signature"])
                    
                    if(SteelBarForm["chop"])
                        getSrc("Chop", SteelBarForm["chop"])
    
                    var list: string[] = [];
                    for(var index = 0; index <= SteelBarForm.additionInfo.length - 1; index++){
                        list.push(SteelBarForm.additionInfo[index].stockistCert ?? "");
                    }
    
                    console.log(list)
                    if(list.length !== 0)
                        getSrcCert("StockistCert", list)
    
    
                    list = [];
                    for(index = 0; index <= SteelBarForm.additionInfo.length - 1; index++){
                        list.push(SteelBarForm.additionInfo[index].millCert ?? "");
                    }
    
                    console.log(list)
                    if(list.length !== 0)
                        getSrcCert("MillCert", list)
    
                }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[SteelBarForm])
    

    useEffect(()=>{
        if(JSON.stringify(steelBarFormData) !== '{}'){
            localStorage.setItem('steelBarFormDataEdit', JSON.stringify(steelBarFormData))
        }
    },[steelBarFormData])

    useEffect(()=>{
        if(JSON.stringify(specimensData) !== '{}'){
            localStorage.setItem('specimensDataEdit', JSON.stringify(specimensData))
        }
    },[specimensData])

    useEffect(()=>{
        if(JSON.stringify(testReportData) !== '{}'){
            localStorage.setItem('testReportDataEdit', JSON.stringify(testReportData))
        }
    },[testReportData])

    const handleClear =async () =>{
        localStorage.removeItem('steelBarFormDataEdit')
        localStorage.removeItem('specimensDataEdit')
        localStorage.removeItem('testReportDataEdit')
        window.location.reload()
    }

    /* useEffect(()=>{
        if(imgData.idPhoto){
            setSrcidPhoto(URL.createObjectURL(imgData.idPhoto))
        }else{
            setSrcidPhoto("")
        }
     },[imgData.idPhoto])    */ 

     useEffect(()=>{
        if(imgData.signature){
            setSrcSignature(URL.createObjectURL(imgData.signature))
            setTypeSign(imgData.SignatureDocType!)
        }else{
            setSrcSignature("")
            setTypeSign("")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     },[imgData.signature]) 

     useEffect(()=>{
        if(imgData.Chop){
            setSrcChopNew(URL.createObjectURL(imgData.Chop))
            setType(imgData.ChopDocType!)
        }else{
            setSrcChopNew("")
            setType("")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     },[imgData.Chop]) 

     /* useEffect(()=>{
        if(imgData.signatureSteel){
            setSrcSignatureSteel(URL.createObjectURL(imgData.signatureSteel))
        }else{
            setSrcSignatureSteel("")
        }
     },[imgData.signatureSteel]) 

     useEffect(()=>{
        if(imgData.signatureChemistry){
            setSrcSignatureChemistry(URL.createObjectURL(imgData.signatureChemistry))
        }else{
            setSrcSignatureChemistry("")
        }
     },[imgData.signatureChemistry])  */

    var objectToFormData = function(obj: any, form: any, namespace: any) {
    
        var fd = form || new FormData();
        var formKey;
        
        for(var property in obj) {
          if(obj.hasOwnProperty(property)) {
            
            if(namespace) {
              formKey = namespace + '[' + property + ']';
            } else {
              formKey = property;
            }
           
            // if the property is an object, but not a File,
            // use recursivity.
            if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
              
              objectToFormData(obj[property], fd, property);
              
            } else {
              
              // if it's a string or a File object
              fd.set(formKey, obj[property]);
            }
            
          }
        }
        
        return fd;
          
      };

      const handleDataUpload = async (apitype: string | null = null) =>{
        
        var specimensDataList: { id: string | null; setNum: number | string; batchNum: string; massInBatch: string; nominalSize: string; grade: string; barPattern: string; class: string; customerSampleId: string; tensile: string; bendPerformance: string; bondPorperty: string; chemicalComposition: string; customer: string;}[] = [];
        if(Object.keys(specimensData).length !== 0){
            
            let processedData = new SpecimensModel();


             Object.keys(specimensData).forEach(key => {
                const value = specimensData[key as keyof SpecimensModel];
                const newArray: any = value !== undefined ? [...value] : [];
                while (newArray.length < findLongestArray(specimensData).length) {
                newArray.push(''); // Append empty strings for missing indices
                }
                processedData[key as keyof SpecimensModel] = newArray;
            });

            console.log(processedData)
            for(var i = 0; i <= findLongestArray(specimensData).length - 1; i++){
                var classType: string = steelBarFormData.testingAccordance === "CS2 : 2012" ? processedData.class !== undefined ? processedData.class![i] !== undefined ? specimensData.class![i] : "" : "" : "";

                specimensDataList.push(
                {
                    id: processedData.id !== undefined ? processedData.id![i] !== undefined ? processedData.id![i] ?? null :  null : null,
                    setNum: processedData.setNO !== undefined ? processedData.setNO![i] !== undefined  && processedData.setNO![i].toString() !== "" ? processedData.setNO![i] ?? (i + 1) : (i + 1) : (i + 1),
                    batchNum: processedData.batchNO !== undefined ? processedData.batchNO![i] !== undefined ? processedData.batchNO![i] ?? "" :  "" : "",
                    massInBatch: processedData.massInBatch !== undefined ? processedData.massInBatch![i] !== undefined ? processedData.massInBatch![i].toString() ?? "" :  "" : "",
                    nominalSize: processedData.nominalSize !== undefined ? processedData.nominalSize![i] !== undefined ? processedData.nominalSize![i].toString() ?? "" :  "" : "",
                    grade: processedData.grade !== undefined ? processedData.grade![i] !== undefined ? processedData.grade![i] ?? "" :  "" : "",
                    barPattern: processedData.barPattern !== undefined ? processedData.barPattern![i] !== undefined ? processedData.barPattern![i] ?? "" :  "" : "",
                    class: classType,
                    customerSampleId: processedData.customerSampleIdentityNO !== undefined ? processedData.customerSampleIdentityNO![i] !== undefined ? processedData.customerSampleIdentityNO![i] ?? "" :  "" : "",
                    tensile: processedData.numberOfTestSpecimenTensile !== undefined ? processedData.numberOfTestSpecimenTensile![i] !== undefined ? processedData.numberOfTestSpecimenTensile![i].toString() ?? "" :  "" : "",
                    bendPerformance: processedData.numberOfTestSpecimenBendPerformance !== undefined ? processedData.numberOfTestSpecimenBendPerformance![i] !== undefined ? processedData.numberOfTestSpecimenBendPerformance![i].toString() ?? "" :  "" : "",
                    bondPorperty: processedData.numberOfTestSpecimenBondProperty !== undefined ? processedData.numberOfTestSpecimenBondProperty![i] !== undefined ? processedData.numberOfTestSpecimenBondProperty![i].toString() ?? "" :  "" : "",
                    chemicalComposition: processedData.numberOfTestSpecimenChemicalComposition !== undefined ? processedData.numberOfTestSpecimenChemicalComposition![i] !== undefined ? processedData.numberOfTestSpecimenChemicalComposition![i].toString() ?? "" :  "" : "",
                    customer: processedData.customer === undefined ? processedData.customer![i] === undefined ? processedData.customer![i] ?? "" :  "" : "",
                });
            }
        }
        /* specimensData.batchNO?.map(async (column, index)=>{
            
            var classType: string = steelBarFormData.testingAccordance === "CS2 : 2012" ? specimensData.class![index] : "";

            specimensDataList.push(
            {
                id: specimensData.id![index],
                setNum: specimensData.setNO![index],
                batchNum: specimensData.batchNO![index],
                massInBatch: specimensData.massInBatch![index].toString(),
                nominalSize: specimensData.nominalSize![index].toString(),
                grade: specimensData.grade![index],
                barPattern: specimensData.barPattern![index],
                class: classType,
                customerSampleId: specimensData.customerSampleIdentityNO![index],
                tensile: specimensData.numberOfTestSpecimenTensile![index].toString(),
                bendPerformance: specimensData.numberOfTestSpecimenBendPerformance![index].toString(),
                bondPorperty: specimensData.numberOfTestSpecimenBondProperty![index].toString(),
                chemicalComposition: specimensData.numberOfTestSpecimenChemicalComposition![index].toString(),
                customer: specimensData.customer![index],
            });
        }); */


        /* var testReportDataList: { id: string; setNum: number; deliveryNoteNum: string; stockistCertNum: string; lotNum: string; millCertNum: string; heatNum: string; }[] = [];
        if(Object.keys(testReportData).length !== 0){
            
            var processedData = new TestReportModel();


             Object.keys(testReportData).forEach(key => {
                const value = testReportData[key as keyof TestReportModel];
                const newArray: any = value !== undefined ? [...value] : [];
                while (newArray.length < findLongestArray(testReportData).length) {
                newArray.push(''); // Append empty strings for missing indices
                }
                processedData[key as keyof TestReportModel] = newArray;
            });

            console.log(processedData)
            for(i = 0; i <= findLongestArray(testReportData).length - 1; i++){
                testReportDataList.push(
                {
                    id: processedData.id === undefined ? processedData.id![i] === undefined ? "" :  "" : processedData.id![i] ?? "",
                    setNum: processedData.setNO === undefined ? processedData.setNO![i] === undefined ? i + 1 :  i + 1 : processedData.setNO![i] ?? i + 1,
                    deliveryNoteNum: processedData.deliveryNoteNO === undefined ? processedData.deliveryNoteNO![i] === undefined ? "" :  "" : processedData.deliveryNoteNO![i] ?? "",
                    stockistCertNum: processedData.stockistCertNO === undefined ? processedData.stockistCertNO![i] === undefined ? "" :  "" : processedData.stockistCertNO![i] ?? "",
                    lotNum: processedData.lotNO === undefined ? "" : processedData.lotNO![i] === undefined ? "" :  processedData.lotNO![i] ?? "",
                    millCertNum: processedData.millCertNO === undefined ? "" : processedData.millCertNO![i] === undefined ? "" : processedData.millCertNO![i] ?? "",
                    heatNum: processedData.heatNO === undefined ? "" : processedData.heatNO![i] === undefined ? "" :  processedData.heatNO![i] ?? "",
                });
            }
        } */

        var steelBarFormDataDto = {
            Id: formId,
            ContractNum: steelBarFormData.contractNO,
            CustomerRef: steelBarFormData.customerRefNO,
            Customer: steelBarFormData.customer,
            Project: steelBarFormData.project,
            DateDeliveredToSite: steelBarFormData.dateDelivered,
            Supplier: steelBarFormData.supplier,
            TestMethod: steelBarFormData.testingAccordance,
            TestMethodOther: steelBarFormData.testingAccordanceOther,
            //IS_OTHER_TESTING_ACCORDANCE: steelBarFormData.isOtherTestingAccordance,
            ExpressTestService: steelBarFormData.expressOrNot === false ? 0 : steelBarFormData.expressThirtyOrFifty === "30%" ? 1 : 2,
            //STEEL_LABORATORY_FEEDBACK: steelBarFormData.steelLaboratoryFeedback,
            //CHEMISTRY_LABORATORY_FEEDBACK: steelBarFormData.chemistryLaboratoryFeedback,
            Statement: Number(steelBarFormData.conformity) - 1,
            Contact: steelBarFormData.contactPerson,
            TelNum: steelBarFormData.telNO,
            FaxNum: steelBarFormData.faxNO,
            Email: steelBarFormData.email,
            ReportTo: steelBarFormData.sendTo,
            BillTo: steelBarFormData.billTo,
            Specimen: JSON.stringify(specimensDataList),
            Remark: steelBarFormData.remark,
            //AdditionInfo: JSON.stringify(testReportDataList),

        }
        var ImgDataChopAndSignature = null;
        if((localStorage.getItem("role") === "0" && status !== "0")){
            if(imgData.ChopDocType !== undefined){
                ImgDataChopAndSignature = {
                    Chop: imgData.Chop,
                }
            }
        }else{
            if (imgData.ChopDocType !== undefined && imgData.SignatureDocType !== undefined){
                ImgDataChopAndSignature = {
                    Chop: imgData.Chop,
                    Signature: imgData.signature,
                }
            }else if(imgData.ChopDocType !== undefined){
                ImgDataChopAndSignature = {
                    Chop: imgData.Chop,
                }
            }else if (imgData.SignatureDocType !== undefined){
                ImgDataChopAndSignature = {
                    Signature: imgData.signature,
                }
            }
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        //var ImgDataChopAndSignature = {
            //ChopGenre: imgData.ChopGenre,
            //Chop: imgData.Chop,
            //ChopDocType: imgData.ChopDocType,
            //SignatureGenre: imgData.SignatureGenre,
            //Signature: imgData.signature,
            //MillCert: JSON.stringify(imgData.MillCert),
            //StockistCert: JSON.stringify(imgData.StockistCert),
            //SignatureDocType: imgData.SignatureDocType,
            //SignatureGenreSteel: imgData.SignatureGenreSteel,
            //SignatureImgFormSteel: imgData.signatureSteel,
            //SignatureDocTypeSteel: imgData.SignatureDocTypeSteel,
            //SignatureGenreChemistry: imgData.SignatureGenreChemistry,
            //SignatureImgFormChemistry: imgData.signatureChemistry,
            //SignatureDocTypeChemistry: imgData.SignatureDocTypeChemistry,
        //}
        /* var specimensDataDto: {[k: string]: string | number} = {};
        specimensData.batchNO?.map(async (column, index)=>{
            specimensDataDto["Specimen[" + index + "].setNum"] = index + 1;
            specimensDataDto["Specimen[" + index + "].batchNum"] = specimensData.batchNO![index];
            specimensDataDto["Specimen[" + index + "].massInBatch"] = specimensData.massInBatch![index];
            specimensDataDto["Specimen[" + index + "].nominalSize"] = specimensData.nominalSize![index];
            specimensDataDto["Specimen[" + index + "].grade"] = specimensData.grade![index];
            specimensDataDto["Specimen[" + index + "].barPattern"] = specimensData.barPattern![index];
            if(steelBarFormData.testingAccordance === "CS2 : 2012"){
                specimensDataDto["Specimen[" + index + "].class"] = specimensData.class![index];
            }
            specimensDataDto["Specimen[" + index + "].customerSampleId"] = specimensData.customerSampleIdentityNO![index];
            specimensDataDto["Specimen[" + index + "].tensile"] = specimensData.numberOfTestSpecimenTensile![index];
            specimensDataDto["Specimen[" + index + "].bendPerformance"] = specimensData.numberOfTestSpecimenBendPerformance![index];
            specimensDataDto["Specimen[" + index + "].bondPorperty"] = specimensData.numberOfTestSpecimenBondProperty![index];
            specimensDataDto["Specimen[" + index + "].chemicalComposition"] = specimensData.numberOfTestSpecimenChemicalComposition![index];

        }); */

        var testReportDataDto: {[k: string]: string | number | null} = {};
        if(Object.keys(testReportData).length !== 0){
            
            var processedData = new TestReportModel();

            var longestArray = findLongestArray(testReportData).length > findLongestArray(imgData).length ? findLongestArray(testReportData).length : findLongestArray(imgData).length;

             Object.keys(testReportData).forEach(key => {
                const value = testReportData[key as keyof TestReportModel];
                const newArray: any = value !== undefined ? [...value] : [];
                while (newArray.length < longestArray) {
                newArray.push(''); // Append empty strings for missing indices
                }
                processedData[key as keyof TestReportModel] = newArray;
            });
            var value = imgData.StockistCert;
            var newArray: any = value !== undefined ? [...value] : [];
            while (newArray.length < longestArray) {
            newArray.push(null); // Append empty strings for missing indices
            }
            imgData.StockistCert = newArray;

            value = imgData.MillCert;
            newArray = value !== undefined ? [...value] : [];
            while (newArray.length < longestArray) {
            newArray.push(null); // Append empty strings for missing indices
            }
            imgData.MillCert = newArray;

            console.log(processedData)
            for(var index = 0; index <= longestArray - 1; index++){
                testReportDataDto["AdditionInfo[" + index + "].id"] = processedData.id![index] ?? null;
                testReportDataDto["AdditionInfo[" + index + "].setNum"] = (index + 1);
                testReportDataDto["AdditionInfo[" + index + "].deliveryNoteNum"] = processedData.deliveryNoteNO![index];
                testReportDataDto["AdditionInfo[" + index + "].stockistCertNum"] = processedData.stockistCertNO![index];
                testReportDataDto["AdditionInfo[" + index + "].lotNum"] = processedData.lotNO![index];
                testReportDataDto["AdditionInfo[" + index + "].millCertNum"] = processedData.millCertNO![index];
                testReportDataDto["AdditionInfo[" + index + "].heatNum"] = processedData.heatNO![index];
                testReportDataDto["AdditionInfo[" + index + "].millCert"] = imgData.MillCert![index];
                testReportDataDto["AdditionInfo[" + index + "].millCertId"] = SteelBarForm!.additionInfo[index] !== undefined ? SteelBarForm!.additionInfo[index].millCert ?? null : null;
                testReportDataDto["AdditionInfo[" + index + "].stockistCert"] = imgData.StockistCert![index];
                testReportDataDto["AdditionInfo[" + index + "].stockistCertId"] = SteelBarForm!.additionInfo[index] !== undefined ? SteelBarForm!.additionInfo[index].stockistCert ?? null : null;
            }
        }

        /* var testReportDataDto: {[k: string]: string | number} = {};
        if(Object.keys(testReportData).length !== 0){
            testReportData.deliveryNoteNO?.map(async (column, index)=>{
                testReportDataDto["AdditionInfo[" + index + "].setNum"] = index + 1;
                testReportDataDto["AdditionInfo[" + index + "].deliveryNoteNum"] = testReportData.deliveryNoteNO![index];
                testReportDataDto["AdditionInfo[" + index + "].stockistCertNum"] = testReportData.stockistCertNO![index];
                testReportDataDto["AdditionInfo[" + index + "].lotNum"] = testReportData.lotNO![index];
                testReportDataDto["AdditionInfo[" + index + "].millCertNum"] = testReportData.millCertNO![index];
                testReportDataDto["AdditionInfo[" + index + "].heatNum"] = testReportData.heatNO![index];
                testReportDataDto["AdditionInfo[" + index + "].millCert"] = imgData.MillCert![index];
                testReportDataDto["AdditionInfo[" + index + "].stockistCert"] = imgData.StockistCert![index];
            });
        } */

        var formdata = new FormData();

        
        steelBarFormDataDto = clearEmptyFields(steelBarFormDataDto, null);

        objectToFormData(steelBarFormDataDto, formdata, "");
        if(ImgDataChopAndSignature !== null){
            ImgDataChopAndSignature = clearEmptyFields(ImgDataChopAndSignature, null);
            objectToFormData(ImgDataChopAndSignature, formdata, "");
        }
        //objectToFormData(specimensDataDto, formdata, "");
        if(Object.keys(testReportData).length !== 0){
            testReportDataDto = clearEmptyFields(testReportDataDto, null);
            objectToFormData(testReportDataDto, formdata, "");
        }

        console.log(formdata);
        if(localStorage.accessToken){
            if(apitype === 'save'){
                return await api.put(`/SteelBarForm/save`, formdata)
            }else{
                if(localStorage.getItem("role") === "2" || localStorage.getItem("role") === "1" || status === "0"){
                    return await api.put(`/SteelBarForm/save/submit`, formdata, {withCredentials: true})
                }else{
                    return await api.put(`/SteelBarForm`, formdata, {withCredentials: true})
                }
            }
        }else{
            if(apitype === 'save'){
                return await api.put(`/SteelBarForm/save`, formdata, {withCredentials: true})
            }else{
                if(localStorage.getItem("role") === "2" || localStorage.getItem("role") === "1" || status === "0"){
                    return await api.put(`/SteelBarForm/save/submit`, formdata, {withCredentials: true})
                }else{
                    return await api.put(`/SteelBarForm`, formdata, {withCredentials: true})
                }
            }
        }
        // await axios.post('/Form/PostEmployee', formdata).then(async (response)=>{
        //     educationData.nameOfEdu?.map(async (column, index)=>{
        //         await axios.post('/Form/PostEducation', {EMPLOYEE_ID: response.data, FROM_DATE: educationData.fromDate![index], TO_DATE: educationData.toDate![index], MAJOR: educationData.major![index], NAME_OF_EDU: educationData.nameOfEdu![index], 
        //             QUALIFICATION: educationData.qualifcation![index]})
        //     })
        //     expData.employer?.map(async (column, index)=>{
        //         await axios.post('/Form/PostExperience', {EMPLOYEE_ID: response.data,FROM_DATE: expData.fromDate![index], TO_DATE: expData.toDate![index], EMPLOYER: expData.employer![index], LAST_POSITION: expData.lastPosition![index], LAST_SALARY: expData.lastSalary![index],
        //             REASON_OF_LEAVING: expData.leavingReason![index]})
        //     })
        //     if (imgData.signature !== undefined){
        //         var ImgDataDto = {
        //             Genre: imgData.signature!.get("Genre"),
        //             ImgForm: imgData.signature!.get("ImgForm"),
        //             DocType: imgData.signature!.get("DocType")
        //         }
        //         objectToFormData(EmployeeDataDto, imgData.signature!, "");
        //         imgData.signature!.set("ID", response.data);
        //         console.log(imgData.signature!);
        //         console.log(imgData.signature!.get("ImgForm"));
        //         await axios.post('/Form/PostEmployee', imgData.signature!);
        //     }
        // });
        
    }
const globalState = useContext(GlobalStateContext);
useEffect(()=>{
      
        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
            api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
        }

        //getRecord();
    },[globalState])

    const fieldToTabMap: { [key: string]: string } = {
        formGridContractNo: 'Part I',
        formGridCustomerRefNo: 'Part I',
        formGridCustomer: 'Part I',
        formGridProject: 'Part I',
        formGridDateDeliveredToSite: 'Part I',
        formGridSupplier: 'Part I',
        formGridContactPerson: "Part IV",
        formGridTelNO: "Part IV",
        formGridFaxNO: "Part IV",
        formGridEmail: "Part IV",
        formGridSendTo: "Part IV",
        formBillTestingFeesTo: "Part IV",
    };
    

    const [formSubmit, setFormSubmit] = useState<any>();
    const [OpenConfirm, setOpenConfirm] = useState(false);

    const handlePreSubmit = (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {

        event.preventDefault();
        event.stopPropagation();

        setFormSubmit(event!.currentTarget);
        if(localStorage.getItem("role") !== "0" || status === "0"){
            setOpenConfirm(true);
        }
        else{
            handleSubmit(event!.currentTarget)
        }
    }

    const handleSubmit = (currentTarget: any) => {
        const form = currentTarget ?? formSubmit!;
        //const form = event.currentTarget;

        
        //event.preventDefault();
        //event.stopPropagation();

        console.log(steelBarFormData);
        if (submitting) 
            return;

        setsubmitting(true);
        
        var errorMsg = "";

        //errorMsg = SignatureValid.checkSignature(imgData, errorMsg, false);



        if (form.checkValidity() === false) {
        setsubmitting(false);
        
        toast.error("Please fill all required fields 請填寫所有必填欄位", {
            className: "custom-toast",
        });
        //toast.error(errorMsg);


        var keyStringList: string[] = [];

        // Find the first invalid field and its corresponding tab
        let firstInvalidTab = null;
        for (const fieldName in fieldToTabMap) {
            const inputElement = form.elements[fieldName];
            if (inputElement && !inputElement.checkValidity()) {
            firstInvalidTab = fieldToTabMap[fieldName];
            break;
            }
        }
        if(steelBarFormData.testingAccordance === undefined || steelBarFormData.testingAccordance === null){
            keyStringList.push("Part I");
        }
        if (firstInvalidTab) {
            keyStringList.push(firstInvalidTab); // Switch to the tab with the first invalid field
        }
        if(steelBarFormData.expressOrNot === undefined || steelBarFormData.conformity === undefined){
            keyStringList.push("Part III")
        }
        if ((imgData.StockistCert === null || imgData.StockistCert === undefined || imgData.StockistCert[0] === null || imgData.StockistCert[0] === undefined) && steelBarFormData.testingAccordance === "CS2 : 2012")
        {
            keyStringList.push("Part I")
        }
        /* for(var index = 0; index < numberOfTestReportstate; index++){

            if (imgData.MillCert === null || imgData.MillCert === undefined || imgData.MillCert[index] === null || imgData.MillCert[index] === undefined)
            {
                keyStringList.push("Part V")
            }
            else if (imgData.StockistCert === null || imgData.StockistCert === undefined || imgData.StockistCert[index] === null || imgData.StockistCert[index] === undefined)
            {
                keyStringList.push("Part V")
            }
            else if (testReportData.stockistCertNO === undefined || testReportData.stockistCertNO[index] === "" 
                || testReportData.stockistCertNO[index] === undefined)
            {
                keyStringList.push("Part V")
            }
            else if (testReportData.millCertNO === undefined || testReportData.millCertNO[index] === "" 
                || testReportData.millCertNO[index] === undefined)
            {
                keyStringList.push("Part V")
            }
        } */
        for(var index = 0; index < numberOfSpecimensstate; index++){
            //if(specimensData.batchNO === undefined || specimensData.batchNO[index] === "" || specimensData.batchNO[index] === undefined){
            //    keyStringList.push("Part II")
            //}else 
            if(specimensData.massInBatch === undefined || specimensData.massInBatch[index] === undefined){
                keyStringList.push("Part II")
            }else if(specimensData.nominalSize === undefined || specimensData.nominalSize[index] === undefined){
                keyStringList.push("Part II")
            }else if(specimensData.grade === undefined || specimensData.grade[index] === "" || specimensData.grade[index] === undefined){
                keyStringList.push("Part II")
            }else if(specimensData.barPattern === undefined || specimensData.barPattern[index] === "" || specimensData.barPattern[index] === undefined){
                keyStringList.push("Part II")
            }//else if(specimensData.customerSampleIdentityNO === undefined || specimensData.customerSampleIdentityNO[index] === "" || specimensData.customerSampleIdentityNO[index] === undefined){
            //    keyStringList.push("Part II")
            //}
         }

        if(keyStringList.length !== 0){
            if(keyStringList.includes("Part I")){
                setKey("Part I")
            }else if(keyStringList.includes("Part II")){
                setKey("Part II")
            }else if(keyStringList.includes("Part III")){
                setKey("Part III")
            }else if(keyStringList.includes("Part IV")){
                setKey("Part IV")
            }else if(keyStringList.includes("Part V")){
                setKey("Part V")
            }  
        }

        setValidated(true);
        }
        else if(errorMsg !== "")
        {
            //toast.error(errorMsg)
            alert(errorMsg);
            setsubmitting(false);
        }
        else
        {

            handleDataUpload().then((response)=>{
                if (response.status !== 200){
                    alert("Fail to submit. \n 提交失敗。")
                    setsubmitting(false);
                }else{
                    localStorage.removeItem('steelBarFormDataEdit')
                    localStorage.removeItem('specimensDataEdit')
                    localStorage.removeItem('testReportDataEdit')
                    if(localStorage.getItem("role") !== "0" || status === "0"){
                        handleClickOpenSuccess();
                    }else{
                        handleClickOpenSuccessEdit();
                    }
                }
            }).catch((e)=>{
                console.log(e)
                alert("Fail to submit. \n 提交失敗。" )
                setsubmitting(false);
            })
        }
        
    };

    const updateSpecimensList = (index: number) => {
            // (specimensList).push(
                
            
            // );
            setSpecimensList((specimensList: any) => [...specimensList, 

                <></>
            ]);
            if(copyAndAdd === true){
                
                setCopyAndAddList((copyAndAddList: any) => [...copyAndAddList, 

                    true
                ]);

                var batchNOList = specimensData.batchNO ? specimensData.batchNO : []
                batchNOList![numberOfSpecimens - 1] = specimensData.batchNO ? 
                specimensData.batchNO.length >= numberOfSpecimens - 1 ? 
                specimensData.batchNO[index] 
                : ""
                : ""

                var batchNOList = specimensData.batchNO ? specimensData.batchNO : []
                batchNOList![numberOfSpecimens - 1] = specimensData.batchNO ? 
                specimensData.batchNO.length >= numberOfSpecimens - 1 ? 
                specimensData.batchNO[index] 
                : ""
                : ""

                var massInBatchList = specimensData.massInBatch ? specimensData.massInBatch : []
                massInBatchList![numberOfSpecimens - 1] = specimensData.massInBatch ? 
                specimensData.massInBatch.length >= numberOfSpecimens - 1 ? 
                specimensData.massInBatch[index] 
                : 0
                : 0

                var nominalSizeList = specimensData.nominalSize ? specimensData.nominalSize : []
                nominalSizeList![numberOfSpecimens - 1] = specimensData.nominalSize ? 
                specimensData.nominalSize.length >= numberOfSpecimens - 1 ? 
                specimensData.nominalSize[index] 
                : 0
                : 0

                var gradeList = specimensData.grade ? specimensData.grade : []
                gradeList![numberOfSpecimens - 1] = specimensData.grade ? 
                specimensData.grade.length >= numberOfSpecimens - 1 ? 
                specimensData.grade[index] 
                : "" 
                : ""

                var barPatternList = specimensData.barPattern ? specimensData.barPattern : []
                barPatternList![numberOfSpecimens - 1] = specimensData.barPattern ? 
                specimensData.barPattern.length >= numberOfSpecimens - 1 ? 
                specimensData.barPattern[index] 
                : ""
                : ""

                var classList = specimensData.class ? specimensData.class : []
                classList![numberOfSpecimens - 1] = specimensData.class ? 
                specimensData.class.length >= numberOfSpecimens - 1 ? 
                specimensData.class[index] 
                : "Class 1"
                : "Class 1"

                var customerSampleIdentityNOList = specimensData.customerSampleIdentityNO ? specimensData.customerSampleIdentityNO : []
                customerSampleIdentityNOList![numberOfSpecimens - 1] = 
                specimensData.customerSampleIdentityNO ? 
                specimensData.customerSampleIdentityNO.length >= numberOfSpecimens - 1 ? 
                specimensData.customerSampleIdentityNO[index] 
                : ""
                : ""

                var numberOfTestSpecimenTensileList = specimensData.numberOfTestSpecimenTensile ? specimensData.numberOfTestSpecimenTensile : []
                numberOfTestSpecimenTensileList![numberOfSpecimens - 1] = 
                specimensData.numberOfTestSpecimenTensile ? 
                specimensData.numberOfTestSpecimenTensile.length >= numberOfSpecimens - 1 ? 
                specimensData.numberOfTestSpecimenTensile[index] 
                : 0
                : 0

                var numberOfTestSpecimenBendPerformanceList = specimensData.numberOfTestSpecimenBendPerformance ? specimensData.numberOfTestSpecimenBendPerformance : []
                numberOfTestSpecimenBendPerformanceList![numberOfSpecimens - 1] = 
                specimensData.numberOfTestSpecimenBendPerformance ? 
                specimensData.numberOfTestSpecimenBendPerformance.length >= numberOfSpecimens - 1 ? 
                specimensData.numberOfTestSpecimenBendPerformance[index] 
                : 0
                : 0

                var numberOfTestSpecimenBondPropertyList = specimensData.numberOfTestSpecimenBondProperty ? specimensData.numberOfTestSpecimenBondProperty : []
                numberOfTestSpecimenBondPropertyList![numberOfSpecimens - 1] = specimensData.numberOfTestSpecimenBondProperty ? 
                specimensData.numberOfTestSpecimenBondProperty.length >= numberOfSpecimens - 1 ? 
                specimensData.numberOfTestSpecimenBondProperty[index] 
                : 0
                : 0

                var numberOfTestSpecimenChemicalCompositionList = specimensData.numberOfTestSpecimenChemicalComposition ? specimensData.numberOfTestSpecimenChemicalComposition : []
                numberOfTestSpecimenChemicalCompositionList![numberOfSpecimens - 1] = specimensData.numberOfTestSpecimenChemicalComposition ? 
                specimensData.numberOfTestSpecimenChemicalComposition.length >= numberOfSpecimens - 1 ?
                specimensData.numberOfTestSpecimenChemicalComposition[index] 
                : 0
                : 0
                                    

                setSpecimens({...specimensData
                    
                    , batchNO: batchNOList
                    , massInBatch: massInBatchList
                    , nominalSize: nominalSizeList
                    , grade: gradeList
                    , barPattern: barPatternList
                    , class: classList
                    , customerSampleIdentityNO: customerSampleIdentityNOList
                    , numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList
                    , numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList
                    , numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList
                    , numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList
                })
                console.log(specimensData);
            }else{
                console.log(copyAndAddList)
                setCopyAndAddList((copyAndAddList: any) => [...copyAndAddList, 

                    false
                ]);

                var batchNOList = specimensData.batchNO ? specimensData.batchNO : []
                if(batchNOList![numberOfSpecimens - 1] === undefined){
                    batchNOList![numberOfSpecimens - 1] = ""
                }


                var massInBatchList = specimensData.massInBatch ? specimensData.massInBatch : []
                if(massInBatchList![numberOfSpecimens - 1] === undefined){
                    massInBatchList![numberOfSpecimens - 1] = 0
                }


                var nominalSizeList = specimensData.nominalSize ? specimensData.nominalSize : []
                if(nominalSizeList![numberOfSpecimens - 1] === undefined){
                    nominalSizeList![numberOfSpecimens - 1] = 0
                }


                var gradeList = specimensData.grade ? specimensData.grade : []
                if(gradeList![numberOfSpecimens - 1] === undefined){
                    gradeList![numberOfSpecimens - 1] = ""
                }

                
                var barPatternList = specimensData.barPattern ? specimensData.barPattern : []
                if(barPatternList![numberOfSpecimens - 1] === undefined){
                    barPatternList![numberOfSpecimens - 1] = ""
                }


                classList = specimensData.class ? specimensData.class : []
                if(classList![numberOfSpecimens - 1] === undefined){
                    classList![numberOfSpecimens - 1] = "Class 1"
                }


                var customerSampleIdentityNOList = specimensData.customerSampleIdentityNO ? specimensData.customerSampleIdentityNO : []
                if(customerSampleIdentityNOList![numberOfSpecimens - 1] === undefined){
                    customerSampleIdentityNOList![numberOfSpecimens - 1] = ""
                }


                numberOfTestSpecimenTensileList = specimensData.numberOfTestSpecimenTensile ? specimensData.numberOfTestSpecimenTensile : []
                if(numberOfTestSpecimenTensileList![numberOfSpecimens - 1] === undefined){
                    numberOfTestSpecimenTensileList![numberOfSpecimens - 1] = 0
                }


                numberOfTestSpecimenBendPerformanceList = specimensData.numberOfTestSpecimenBendPerformance ? specimensData.numberOfTestSpecimenBendPerformance : []
                if(numberOfTestSpecimenBendPerformanceList![numberOfSpecimens - 1] === undefined){
                    numberOfTestSpecimenBendPerformanceList![numberOfSpecimens - 1] = 0
                }


                numberOfTestSpecimenBondPropertyList = specimensData.numberOfTestSpecimenBondProperty ? specimensData.numberOfTestSpecimenBondProperty : []
                if(numberOfTestSpecimenBondPropertyList![numberOfSpecimens - 1] === undefined){
                    numberOfTestSpecimenBondPropertyList![numberOfSpecimens - 1] = 0
                }


                numberOfTestSpecimenChemicalCompositionList = specimensData.numberOfTestSpecimenChemicalComposition ? specimensData.numberOfTestSpecimenChemicalComposition : []
                if(numberOfTestSpecimenChemicalCompositionList![numberOfSpecimens - 1] === undefined){
                    numberOfTestSpecimenChemicalCompositionList![numberOfSpecimens - 1] = 0
                }                   


                setSpecimens({...specimensData
                    
                    , batchNO: batchNOList
                    , massInBatch: massInBatchList
                    , nominalSize: nominalSizeList
                    , grade: gradeList
                    , barPattern: barPatternList
                    , class: classList
                    , customerSampleIdentityNO: customerSampleIdentityNOList
                    , numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList
                    , numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList
                    , numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList
                    , numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList
                })
            }
    };
    

    const updateTestReportList = (index: number) => {
        setTestReportList((testReportList: any) => [...testReportList, 

            <></>
        ]);
        if(copyAndAddTestReport === true){            

            setCopyAndAddTestReportList((copyAndAddTestReportList: any) => [...copyAndAddTestReportList, 

                true
            ]);

            var deliveryNoteNOList = testReportData.deliveryNoteNO ? testReportData.deliveryNoteNO : []
            deliveryNoteNOList![numberOfTestReport - 1] = testReportData.deliveryNoteNO ? 
            testReportData.deliveryNoteNO.length >= numberOfTestReport - 1 ? 
            testReportData.deliveryNoteNO[index] 
            : "" 
            : ""

            var stockistCertNOList = testReportData.stockistCertNO ? testReportData.stockistCertNO : []
            stockistCertNOList![numberOfTestReport - 1] = testReportData.stockistCertNO ? 
            testReportData.stockistCertNO.length >= numberOfTestReport - 1 ? 
            testReportData.stockistCertNO[index] 
            : "" 
            : ""

            var lotNOList = testReportData.lotNO ? testReportData.lotNO : []
            lotNOList![numberOfTestReport - 1] = testReportData.lotNO ? 
            testReportData.lotNO.length >= numberOfTestReport - 1 ? 
            testReportData.lotNO[index] 
            : "" 
            : ""

            var millCertNOList = testReportData.millCertNO ? testReportData.millCertNO : []
            millCertNOList![numberOfTestReport - 1] = testReportData.millCertNO ? 
            testReportData.millCertNO.length >= numberOfTestReport - 1 ? 
            testReportData.millCertNO[index] 
            : "" 
            : ""

            var heatNOList = testReportData.heatNO ? testReportData.heatNO : []
            heatNOList![numberOfTestReport - 1] = testReportData.heatNO ? 
            testReportData.heatNO.length >= numberOfTestReport - 1 ? 
            testReportData.heatNO[index] 
            : "" 
            : ""

            setTestReport({...testReportData
                
                , deliveryNoteNO: deliveryNoteNOList
                , stockistCertNO: stockistCertNOList
                , lotNO: lotNOList
                , millCertNO: millCertNOList
                , heatNO: heatNOList
            })
        }else{
            setCopyAndAddTestReportList((copyAndAddTestReportList: any) => [...copyAndAddTestReportList, 

                false
            ]);

            var deliveryNoteNOList = testReportData.deliveryNoteNO ? testReportData.deliveryNoteNO : []
            if(deliveryNoteNOList![numberOfTestReport - 1] === undefined){
                deliveryNoteNOList![numberOfTestReport - 1] = ""
            }


            var stockistCertNOList = testReportData.stockistCertNO ? testReportData.stockistCertNO : []
            if(stockistCertNOList![numberOfTestReport - 1] === undefined){
                stockistCertNOList![numberOfTestReport - 1] = ""
            }


            var lotNOList = testReportData.lotNO ? testReportData.lotNO : []
            if(lotNOList![numberOfTestReport - 1] === undefined){
                lotNOList![numberOfTestReport - 1] = ""
            }


            var millCertNOList = testReportData.millCertNO ? testReportData.millCertNO : []
            if(millCertNOList![numberOfTestReport - 1] === undefined){
                millCertNOList![numberOfTestReport - 1] = ""
            }


            var heatNOList = testReportData.heatNO ? testReportData.heatNO : []
            if(heatNOList![numberOfTestReport - 1] === undefined){
                heatNOList![numberOfTestReport - 1] = ""
            }


            setTestReport({...testReportData
                
                , deliveryNoteNO: deliveryNoteNOList
                , stockistCertNO: stockistCertNOList
                , lotNO: lotNOList
                , millCertNO: millCertNOList
                , heatNO: heatNOList
            })

        }
        
        console.log(testReportData);
    };

    useEffect(() => {
        if(lastNumberOfSpecimens > numberOfSpecimensstate){
            setSpecimensList((specimensList: string | any[]) => specimensList.slice(0, specimensList.length - 1))
            //var specimenslist = specimensList.filter((_: any, i: number) => i !== index! - 1);
            //setSpecimensList(specimenslist)
        }else{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            numberOfSpecimens = numberOfSpecimensstate
            if(numberOfSpecimens >= 2){
                updateSpecimensList(index!);
            }
        }
    }, [numberOfSpecimensstate]);

    useEffect(() => {
        if(lastNumberOfTestReport > numberOfTestReportstate){
            setTestReportList((testReportList: string | any[]) => testReportList.slice(0, testReportList.length - 1))
        }else{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            numberOfTestReport = numberOfTestReportstate
            if(numberOfTestReport >= 2){
                updateTestReportList(index!);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numberOfTestReportstate]);


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [width, height] = useDeviceSize()
    
    const[key, setKey] = useState("Part I")
    const[DynamicKeyTitle, setDynamicKeyTitle] = useState("Next")

    const handleTabClick = (tabKey: any, event: any) => {
    if (tabKey === 'submit') {
        if(DynamicKeyTitle==="Next"){
            switch(key) {
                case 'Part I':
                    setKey("Part II")
                    break;
                case 'Part II':
                    setKey("Part III")
                    break;
                case 'Part III':
                    setKey("Part IV")
                    break;
                case 'Part IV':
                    setKey("Part V")
                    break;
                case 'Part V':
                    setKey("Part VI")
                    break;
            }
        }else{
            event.preventDefault();
            event.stopPropagation();
            if(submitButtonRef.current !== null){
                submitButtonRef.current.click();
            }
        }
    } else if (tabKey === 'save'){
        event.preventDefault();
        event.stopPropagation();
        if(saveButtonRef.current !== null){
            saveButtonRef.current.click();
        }
    } else {
        setKey(tabKey);
    }
  };

  useEffect(() => {
        if(key === "Part VI"){
            setDynamicKeyTitle("Submit")
        }else{
            setDynamicKeyTitle("Next")
        }
    }, [key]);

const handleSave = (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        //const form = event.currentTarget;

        
        event.preventDefault();
        event.stopPropagation();

        console.log(steelBarFormData);
        if (saving) 
            return;

        setsaving(true);
        


        handleDataUpload("save").then((response)=>{
            if (response.status !== 200){
                alert("Fail to save. \n 保存失敗。")
                setsaving(false);
            }else{
                localStorage.removeItem('steelBarFormDataEdit')
                localStorage.removeItem('specimensDataEdit')
                localStorage.removeItem('testReportDataEdit')
                handleClickOpenSuccessSave();
            }
        }).catch((e)=>{
            console.log(e)
            alert("Fail to save. \n 保存失敗。" )
            setsaving(false);
        })
    };


    return (
      <Container className="justify-content-md-center" style={{maxWidth:"1920px"}}><Form noValidate validated={validated} onSubmit={handlePreSubmit}>
        {width >= 550 && 
        <Row style={{maxWidth:"550px", maxHeight:"360px"}}>
            <Col><Image style={{maxWidth:"250px", maxHeight:"180px", width:"50vw"}} src={castcoTitleIcon}/></Col><Col style={{width:"50vw", maxWidth:"300px", maxHeight:"180px", lineHeight:"12px", fontSize:"16px", marginTop:"26px"}}><p><b>佳力高試驗中心有限公司</b></p><p><b>CASTCO TESTING CENTRE LTD.</b></p></Col>
        </Row>}
        {width < 550 && 
        <Row style={{maxWidth:"550px", maxHeight:"360px"}}>
            <Image style={{maxWidth:"250px", maxHeight:"180px"}} src={castcoTitleIcon}/>
            <Row style={{maxWidth:"300px", maxHeight:"180px", lineHeight:"1px", fontSize:"18px", fontWeight:"bolder"}}>
                <p><b>佳力高試驗中心有限公司</b></p>
            </Row>
            <Row style={{maxWidth:"300px", maxHeight:"180px", lineHeight:"1px", fontSize:"14px", fontWeight:"bolder"}}>
                <p><b>CASTCO TESTING CENTRE LTD.</b></p>
            </Row>
        </Row>}
        <Row className="p-5">
            <h4 className="text-center"><u><b>Testing of Carbon Steel Reinforcing Bars & Stainless Steel Bars</b></u></h4>
            <h4 className="text-center"><u><b>碳素鋼筋、不銹鋼筋測試</b></u></h4>
        </Row>
        
      <Col style={{display: 'flex', justifyContent: 'space-between'}}>
      <Button variant="primary" className="mb-3" onClick={handleClear} style={{ display: 'none' }}>
                Clear
      </Button>
      <Button variant="primary" className="mb-3" onClick={handleSave} disabled={saving} style={{ display: 'none' }} ref={saveButtonRef}>
                Save
      </Button>
      <Button variant="primary" type="submit" disabled={submitting} className="mb-3" style={{ display: 'none' }} ref={submitButtonRef}>
                Submit
      </Button>
      </Col>
        <div className="" style={{width:"inherit"}}>
            <Tabs defaultActiveKey="Part I" id="uncontrolled-tab-example" activeKey={key} className={localStorage.getItem("role") === "2" || localStorage.getItem("role") === "1" || status === "0" ? "tab-container profile-tabs text-light p-3 fw-bold fs-4 bg-success bg-opacity-75" : "profile-tabs text-light p-3 fw-bold fs-4 bg-success bg-opacity-75"} onSelect={handleTabClick}>
                <Tab eventKey="Part I" title="Contract" tabClassName="profile-tabitem"> 
                    <div className="profile-tab-space">
                        <Row className="bg-success bg-opacity-10 pt-3 m-0">
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridContractNo" xs={12} lg={4}>
                                <Form.Label>Contract No. 合約編號 :</Form.Label>
                                <Form.Control defaultValue={steelBarFormData.contractNO}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, contractNO: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.contractNo}
                                </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCustomerRefNo" xs={12} lg={4}>
                                <Form.Label>Customer Ref. No. 客戶參考編號 :</Form.Label>
                                <Form.Control defaultValue={steelBarFormData.customerRefNO}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, customerRefNO: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.customerRefNo}
                                </Form.Control.Feedback>
                                </Form.Group>

                                
                                <Form.Group as={Col} controlId="formGridCustomer" xs={12} lg={4}>
                                    <Form.Label>Customer 客戶名稱 :</Form.Label>
                                    <Form.Control required defaultValue={steelBarFormData.customer}
                                    onChange={e => setSteelBarForm({ ...steelBarFormData, customer: e.target.value})}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.customer}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <Row>

                                <Form.Group as={Col} className="mb-3" controlId="formGridProject"  xs={12} lg={6}>
                                    <Form.Label>Project 項目名稱 :</Form.Label>
                                    <Form.Control  as="textarea" rows={3} required defaultValue={steelBarFormData.project}
                                    onChange={e => setSteelBarForm({ ...steelBarFormData, project: e.target.value})}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.projectName}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridDateDeliveredToSite"  xs={12} lg={2}>
                                <Form.Label>Date Delivered to Site 到達工地日期 :</Form.Label>
                                <Form.Control type="date" required={steelBarFormData.testingAccordance === "CS2 : 2012"} defaultValue={steelBarFormData.dateDelivered}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, dateDelivered: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.dateDelivered}
                                </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridSupplier"  xs={12} lg={4}>
                                <Form.Label>Supplier 供應商 :</Form.Label>
                                <Form.Control required={steelBarFormData.testingAccordance === "CS2 : 2012"} defaultValue={steelBarFormData.supplier}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, supplier: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.supplier}
                                </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Form.Group  as={Col} className="mb-3" id="formGridCheckboxTesting" >
                                <Form.Label>Please carry out Testing is in accordance with 請根據測試標準</Form.Label>
                                <br></br>
                                {steelBarFormData.testingAccordance === "CS2 : 2012" &&
                                <Form.Check inline type="radio" name="radiogroup" label="CS2 : 2012" required defaultChecked
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "CS2 : 2012"});
                                var classList: string[] = []
                                for(var i = 0; i < findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length; i++){
                                    classList.push("Class 1");
                                }
                                setSpecimens({...specimensData, class: classList})
                                }}/>}
                                {steelBarFormData.testingAccordance !== "CS2 : 2012" &&
                                <Form.Check inline type="radio" name="radiogroup" label="CS2 : 2012" required
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "CS2 : 2012"});
                                var classList: string[] = []
                                for(var i = 0; i < findLongestArray(JSON.parse(localStorage.getItem('specimensDataEdit')!)).length; i++){
                                    classList.push("Class 1");
                                }
                                setSpecimens({...specimensData, class: classList})
                                }}/>}

                                {steelBarFormData.testingAccordance === "BS 4449 : 2005" &&
                                <Form.Check inline type="radio" name="radiogroup" label="BS 4449 : 2005" defaultChecked
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "BS 4449 : 2005"});
                                setSpecimens({...specimensData, class: undefined})
                                }}/>}
                                {steelBarFormData.testingAccordance !== "BS 4449 : 2005" &&
                                <Form.Check inline type="radio" name="radiogroup" label="BS 4449 : 2005"
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "BS 4449 : 2005"});
                                setSpecimens({...specimensData, class: undefined})
                                }}/>}

                                {steelBarFormData.testingAccordance === "BS 6744 : 2001"  &&
                                <Form.Check inline type="radio" name="radiogroup" label="BS 6744 : 2001" defaultChecked
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "BS 6744 : 2001"});
                                setSpecimens({...specimensData, class: undefined})
                                }}/>}
                                {steelBarFormData.testingAccordance !== "BS 6744 : 2001"  &&
                                <Form.Check inline type="radio" name="radiogroup" label="BS 6744 : 2001"
                                onClick={e => {setSteelBarForm({ ...steelBarFormData, testingAccordance: "BS 6744 : 2001"});
                                setSpecimens({...specimensData, class: undefined})
                                }}/>}

                                {steelBarFormData.isOtherTestingAccordance === true  &&
                                    <Form.Check inline label="Other" defaultChecked
                                        onClick={
                                            e => {steelBarFormData.isOtherTestingAccordance === true ? 
                                                setSteelBarForm({ ...steelBarFormData, isOtherTestingAccordance: false }) 
                                                : setSteelBarForm({ ...steelBarFormData, isOtherTestingAccordance: true });
                                            setSpecimens({...specimensData, class: undefined})
                                        }}/>
                                }

                                {steelBarFormData.isOtherTestingAccordance !== true  &&
                                    <Form.Check inline label="Other"
                                        onClick={
                                            e => {steelBarFormData.isOtherTestingAccordance === true ? 
                                                setSteelBarForm({ ...steelBarFormData, isOtherTestingAccordance: false }) 
                                                : setSteelBarForm({ ...steelBarFormData, isOtherTestingAccordance: true });
                                            setSpecimens({...specimensData, class: undefined})
                                        }}/>
                                }

                                {steelBarFormData.isOtherTestingAccordance === true &&
                                    <>
                                        <Form.Control required style={{ display: 'inline-block', width: 'auto' }} 
                                            defaultValue={steelBarFormData.testingAccordanceOther}
                                            onChange={e => setSteelBarForm({ ...steelBarFormData, testingAccordanceOther: e.target.value})}/>
                                        <Form.Control.Feedback type="invalid">
                                            {steelBarFormErrorMessages.otherTestDescription}
                                        </Form.Control.Feedback>
                                    </>
                                }
                            </Form.Group>
                            <Form.Group as={Col} controlId = {`formFileStockistCert 1`} xs={12} md={12} lg={12}>
                                    <Form.Label>Stockist Cert 供應商證書 :</Form.Label><br></br>
                                    {SrcStockistCert.length >= 1 && SrcStockistCert[0] !== "" ?
                                        <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcStockistCert[0] + SrcStockistCertType[0]} href={SrcStockistCert[0]}> Stockist Cert Link</a>
                                        : <p>Empty</p>
                                    }
                                    <Form.Control style={{ width: 'auto' }} //required={SrcStockistCert.length >= 1 && SrcStockistCert[0] !== "" ? false : true}
                                        required={steelBarFormData.testingAccordance === "CS2 : 2012" && SrcStockistCert.length === 0}
                                        //{testReportData.stockistCertNO && testReportData.stockistCertNO[numberOfTestReport - 1] !== "" 
                                        //    && testReportData.stockistCertNO[numberOfTestReport - 1] !== undefined  ? true : false} 
                                        type="file" accept=".zip,.pdf,.jpg,.png" 
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                        {
                                            var StockistCertGenreList = imgData.StockistCertGenre ? imgData.StockistCertGenre : []
                                            var StockistCertList = imgData.StockistCert ? imgData.StockistCert : []
                                            var StockistCertDocTypeList = imgData.StockistCertDocType ? imgData.StockistCertDocType : []
                                            StockistCertGenreList![0] = "StockistCert"
                                            StockistCertList![0] = e.target.files![0]
                                            StockistCertDocTypeList![0] = e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]
                                            setImg({...imgData
                                            , StockistCertGenre: StockistCertGenreList
                                            , StockistCert: StockistCertList
                                            , StockistCertDocType: StockistCertDocTypeList})
                                        }}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.stockistCert}
                                    </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    </div>
                </Tab>
                <Tab eventKey="Part II" title="Specimens" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                    <Container className="justify-content-md-center" style={{width: "95%"}}>
                        
                        <Form.Group as={Row} className="mt-3">
                                <Form.Label className="fs-5"><b>for the following specimens taken from captioned project 對以下試件進行測試</b></Form.Label>
                        </Form.Group>
                        <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                            Set NO {numberOfSpecimens}
                        </Row>
                        <Row className="bg-success bg-opacity-10 pt-3">
                            
                            
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId = {`formGridBatchNo ${numberOfSpecimens}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Batch No.<br></br> 批號 :</Form.Label>
                                    <Form.Control
                                    onChange={e => {
                                        var batchNOList = specimensData.batchNO ? specimensData.batchNO : []
                                        batchNOList![numberOfSpecimens - 1] = e.target.value
                                        setSpecimens({...specimensData, batchNO: batchNOList})
                                    }} value={
                                    specimensData.batchNO ?
                                    specimensData.batchNO[numberOfSpecimens - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.batchNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridmassInBatch ${numberOfSpecimens}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Mass in Batch<br></br> 批料重量 (tonne) :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var massInBatchList = specimensData.massInBatch ? specimensData.massInBatch : []
                                        massInBatchList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, massInBatch: massInBatchList})
                                    }} value={
                                        specimensData.massInBatch ?
                                        specimensData.massInBatch[numberOfSpecimens - 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.massInBatch}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnominalSize ${numberOfSpecimens}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Nominal Size<br></br> 鋼筋直徑 (mm) :</Form.Label>
                                    <Form.Control required={steelBarFormData.testingAccordance === "CS2 : 2012"}
                                    type="number"
                                    onChange={e => {
                                        var nominalSizeList = specimensData.nominalSize ? specimensData.nominalSize : []
                                        nominalSizeList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, nominalSize: nominalSizeList})
                                    }} value={
                                        specimensData.nominalSize ?
                                        specimensData.nominalSize[numberOfSpecimens - 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.nominalSize}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridgrade ${numberOfSpecimens}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Grade<br></br> 等級 :</Form.Label>
                                    <Form.Control required
                                    onChange={e => {
                                        var gradeList = specimensData.grade ? specimensData.grade : []
                                        gradeList![numberOfSpecimens - 1] = e.target.value
                                        setSpecimens({...specimensData, grade: gradeList})
                                    }} value={
                                        specimensData.grade ?
                                        specimensData.grade[numberOfSpecimens - 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.grade}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridbarPattern ${numberOfSpecimens}`} xs={12} md={12} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bar Pattern <br></br>鋼筋圖案 :</Form.Label>
                                    <Form.Control required={steelBarFormData.testingAccordance === "CS2 : 2012"}
                                    onChange={e => {
                                        var barPatternList = specimensData.barPattern ? specimensData.barPattern : []
                                        barPatternList![numberOfSpecimens - 1] = e.target.value
                                        setSpecimens({...specimensData, barPattern: barPatternList})
                                    }} value={
                                        specimensData.barPattern ?
                                        specimensData.barPattern[numberOfSpecimens - 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.barPattern}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridcustomerSampleIdentityNO ${numberOfSpecimens}`}  xs={12} md={12} lg={2}>
                                    <Form.Label className="col-form-label col-form-label-sm">Customer Sample Identity No. <br></br>客戶樣本編號 :</Form.Label>
                                    <Form.Control
                                    onChange={e => {
                                        var customerSampleIdentityNOList = specimensData.customerSampleIdentityNO ? specimensData.customerSampleIdentityNO : []
                                        customerSampleIdentityNOList![numberOfSpecimens - 1] = e.target.value
                                        setSpecimens({...specimensData, customerSampleIdentityNO: customerSampleIdentityNOList})
                                    }} value={
                                        specimensData.customerSampleIdentityNO ?
                                        specimensData.customerSampleIdentityNO[numberOfSpecimens - 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.customerSampleIdentityNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {steelBarFormData.testingAccordance === "CS2 : 2012" &&
                                <>
                                <Form.Group as={Col} controlId={`formGridclass ${numberOfSpecimens}`} xs={12} md={12} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Class <br></br> 類型 :</Form.Label>
                                    <Form.Select required 
                                    value={
                                        specimensData.class ?
                                        specimensData.class[numberOfSpecimens - 1] 
                                        : "Class 1"}
                                    onChange={e => {
                                        var classList = specimensData.class ? specimensData.class : []
                                        classList![numberOfSpecimens - 1] = e.target.value
                                        setSpecimens({...specimensData, class: classList})}}>
                                    <option value="Class 1">Class 1</option>
                                    <option value="Class 2">Class 2</option>
                                    </Form.Select>
                                </Form.Group>
                                </>}
                            <Col className="mb-3">

                            <Form.Group as={Row} className="mt-3">
                                <Form.Label className="fs-5 text-center"><b>No. of Test Specimen 測試數量 (see note) :</b></Form.Label>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenTensile ${numberOfSpecimens}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Tensile (Included mass per meter)<br></br> 拉伸性能 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenTensileList = specimensData.numberOfTestSpecimenTensile ? specimensData.numberOfTestSpecimenTensile : []
                                        numberOfTestSpecimenTensileList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList})
                                    }} value={
                                        specimensData.numberOfTestSpecimenTensile ?
                                        specimensData.numberOfTestSpecimenTensile[numberOfSpecimens - 1] 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.tensileCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBendPerformance ${numberOfSpecimens}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bend <br></br>Performance<br></br> 彎曲表現 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenBendPerformanceList = specimensData.numberOfTestSpecimenBendPerformance ? specimensData.numberOfTestSpecimenBendPerformance : []
                                        numberOfTestSpecimenBendPerformanceList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList})
                                    }} value={
                                        specimensData.numberOfTestSpecimenBendPerformance ?
                                        specimensData.numberOfTestSpecimenBendPerformance[numberOfSpecimens - 1] 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.bendCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBondProperty ${numberOfSpecimens}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bond Property<br></br> (Surface Geometry) <br></br>粘結性能 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenBondPropertyList = specimensData.numberOfTestSpecimenBondProperty ? specimensData.numberOfTestSpecimenBondProperty : []
                                        numberOfTestSpecimenBondPropertyList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList})
                                    }} value={
                                        specimensData.numberOfTestSpecimenBondProperty ?
                                        specimensData.numberOfTestSpecimenBondProperty[numberOfSpecimens - 1] 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.bondCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenChemicalComposition ${numberOfSpecimens}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Chemical Composition <br></br>化學分析 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenChemicalCompositionList = specimensData.numberOfTestSpecimenChemicalComposition ? specimensData.numberOfTestSpecimenChemicalComposition : []
                                        numberOfTestSpecimenChemicalCompositionList![numberOfSpecimens - 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList})
                                    }} value={
                                        specimensData.numberOfTestSpecimenChemicalComposition ?
                                        specimensData.numberOfTestSpecimenChemicalComposition[numberOfSpecimens - 1] 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.chemicalCount}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Group>
                            </Col>

                                <p style={{fontSize:"12px", marginTop:"3rem"}}><b>Note : Please refer to table 10 of CS2 : 2012 for the no. of test specimen required relevant to the tonnage in the batch</b></p>
                        
                            </Row>
                        </Row>
                        
                    </Container>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        {numberOfSpecimensstate !== 8 &&
                        <>
                            { <Button variant="primary"
                            onClick={e => {
                                setCopyAndAdd(true);
                                setLastNumberOfSpecimens(numberOfSpecimensstate);
                                setNumberOfSpecimensstate(current=>current+1);
                                setIndex(0)
                            }}>
                            Copy and Add
                            </Button> }
                            <Button variant="primary"onClick={e => {
                                setCopyAndAdd(false);
                                setLastNumberOfSpecimens(numberOfSpecimensstate);
                                setNumberOfSpecimensstate(current=>current+1);
                                setIndex(0)
                            }}>
                            Add
                            </Button>
                        </>}
                        {numberOfSpecimensstate !== 1 &&
                        <>
                            <Button variant="primary"onClick={e => {
                                setCopyAndAdd(false);
                                var list : string[] | number[] = specimensData.id ?? [];
                                
                                var iDList
                                list = list.filter((_, i) => i !== 0)
                                iDList= list

                                list = specimensData.setNO ?? [];
                                var setNOList
                                list = list.filter((_, i) => i !== 0)
                                setNOList = list

                                list = specimensData.batchNO ?? [];
                                var batchNOList
                                list = list.filter((_, i) => i !== 0)
                                batchNOList = list

                                list = specimensData.massInBatch ?? [];
                                var massInBatchList
                                list = list.filter((_, i) => i !== 0)
                                massInBatchList = list


                                list = specimensData.nominalSize ?? [];
                                var nominalSizeList
                                list = list.filter((_, i) => i !== 0)
                                nominalSizeList = list


                                list = specimensData.grade ?? [];
                                var gradeList
                                list = list.filter((_, i) => i !== 0)
                                gradeList = list

                                
                                list = specimensData.barPattern ?? [];
                                var barPatternList
                                list = list.filter((_, i) => i !== 0)
                                barPatternList = list


                                list = specimensData.class ?? [];
                                var classList
                                list = list.filter((_, i) => i !== 0)
                                classList = list


                                list = specimensData.customerSampleIdentityNO ?? [];
                                var customerSampleIdentityNOList
                                list = list.filter((_, i) => i !== 0)
                                customerSampleIdentityNOList = list

                                list = specimensData.numberOfTestSpecimenTensile ?? [];
                                var numberOfTestSpecimenTensileList
                                list = list.filter((_, i) => i !== 0)
                                numberOfTestSpecimenTensileList = list

                                list = specimensData.numberOfTestSpecimenBendPerformance ?? [];
                                var numberOfTestSpecimenBendPerformanceList
                                list = list.filter((_, i) => i !== 0)
                                numberOfTestSpecimenBendPerformanceList = list
                                

                                list = specimensData.numberOfTestSpecimenBondProperty ?? [];
                                var numberOfTestSpecimenBondPropertyList
                                list = list.filter((_, i) => i !== 0)
                                numberOfTestSpecimenBondPropertyList = list
                                

                                list = specimensData.numberOfTestSpecimenChemicalComposition ?? [];
                                var numberOfTestSpecimenChemicalCompositionList
                                list = list.filter((_, i) => i !== 0)
                                numberOfTestSpecimenChemicalCompositionList = list
                                

                                setSpecimens(
                                {
                                    ...specimensData,
                                    id: iDList,
                                    setNO: setNOList, 
                                    batchNO: batchNOList,
                                    massInBatch: massInBatchList,
                                    nominalSize: nominalSizeList,
                                    grade: gradeList,
                                    barPattern: barPatternList,
                                    class: classList,
                                    customerSampleIdentityNO: customerSampleIdentityNOList,
                                    numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList,
                                    numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList,
                                    numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList,
                                    numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList
                                })
                                console.log(specimensData);
                                setLastNumberOfSpecimens(numberOfSpecimensstate);
                                setNumberOfSpecimensstate(current=>current-1);
                                setIndex(1);
                        }}>
                            Remove
                        </Button>
                        </>
                        }
                </div>
                
                {specimensList.map((item: any, index: any)=><React.Fragment key={`formGridSpecimens ${index + 2}`}>
                    <Container className="justify-content-md-center" style={{width: "95%"}}>
                        <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                            Set NO {index + 2}
                        </Row>
                        <Row className="bg-success bg-opacity-10 pt-3">
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId = {`formGridBatchNo ${index + 2}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Batch No. <br></br>批號 :</Form.Label>
                                    <Form.Control
                                    onChange={e => {
                                        var batchNOList = specimensData.batchNO ? specimensData.batchNO : []
                                        batchNOList![index + 1] = e.target.value
                                        setSpecimens({...specimensData, batchNO: batchNOList})
                                    }} defaultValue={specimensData.batchNO ?
                                    specimensData.batchNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.batchNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridmassInBatch ${index + 2}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Mass in Batch <br></br>批料重量 (tonne) :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var massInBatchList = specimensData.massInBatch ? specimensData.massInBatch : []
                                        massInBatchList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, massInBatch: massInBatchList})
                                    }} defaultValue={specimensData.massInBatch ?
                                        specimensData.massInBatch[index + 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.massInBatch}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnominalSize ${index + 2}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Nominal Size <br></br>鋼筋直徑 (mm) :</Form.Label>
                                    <Form.Control required={steelBarFormData.testingAccordance === "CS2 : 2012"}
                                    type="number"
                                    onChange={e => {
                                        var nominalSizeList = specimensData.nominalSize ? specimensData.nominalSize : []
                                        nominalSizeList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, nominalSize: nominalSizeList})
                                    }} defaultValue={specimensData.nominalSize ?
                                        specimensData.nominalSize[index + 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.nominalSize}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridgrade ${index + 2}`} xs={12} md={6} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Grade <br></br>等級 :</Form.Label>
                                    <Form.Control required
                                    onChange={e => {
                                        var gradeList = specimensData.grade ? specimensData.grade : []
                                        gradeList![index + 1] = e.target.value
                                        setSpecimens({...specimensData, grade: gradeList})
                                    }} defaultValue={specimensData.grade ?
                                        specimensData.grade[index + 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.grade}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridbarPattern ${index + 2}`} xs={12} md={12} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bar Pattern <br></br>鋼筋圖案 :</Form.Label>
                                    <Form.Control required={steelBarFormData.testingAccordance === "CS2 : 2012"}
                                    onChange={e => {
                                        var barPatternList = specimensData.barPattern ? specimensData.barPattern : []
                                        barPatternList![index + 1] = e.target.value
                                        setSpecimens({...specimensData, barPattern: barPatternList})
                                    }} defaultValue={specimensData.barPattern ?
                                        specimensData.barPattern[index + 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.barPattern}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                
                                <Form.Group as={Col} controlId={`formGridcustomerSampleIdentityNO ${index + 2}`} xs={12} md={12} lg={2}>
                                    <Form.Label className="col-form-label col-form-label-sm">Customer Sample Identity No. <br></br>客戶樣本編號 :</Form.Label>
                                    <Form.Control
                                    onChange={e => {
                                        var customerSampleIdentityNOList = specimensData.customerSampleIdentityNO ? specimensData.customerSampleIdentityNO : []
                                        customerSampleIdentityNOList![index + 1] = e.target.value
                                        setSpecimens({...specimensData, customerSampleIdentityNO: customerSampleIdentityNOList})
                                    }} defaultValue={specimensData.customerSampleIdentityNO ?
                                        specimensData.customerSampleIdentityNO[index + 1] 
                                        : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.customerSampleIdentityNo}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                
                                {steelBarFormData.testingAccordance === "CS2 : 2012" &&
                                <>
                                <Form.Group as={Col} controlId={`formGridclass ${index + 2}`} xs={12} md={12} lg={1}>
                                    <Form.Label className="col-form-label col-form-label-sm">Class <br></br> 類型 :</Form.Label>
                                    <Form.Select required 
                                    defaultValue={specimensData.class ?
                                            specimensData.class[index + 1] 
                                            : "Class 1"}
                                    onChange={e => {
                                        var classList = specimensData.class ? specimensData.class : []
                                        classList![index + 1] = e.target.value
                                        setSpecimens({...specimensData, class: classList})}}>
                                    <option value="Class 1">Class 1</option>
                                    <option value="Class 2">Class 2</option>
                                    </Form.Select>
                                </Form.Group>
                                </>}
                                
                            <Col className="mb-3">

                            <Form.Group as={Row} className="mt-3">
                                <Form.Label className="fs-5 text-center"><b>No. of Test Specimen 測試數量 (see note) :</b></Form.Label>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Group as={Col}  controlId={`formGridnumberOfTestSpecimenTensile ${index + 2}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Tensile (Included mass per meter) <br></br>拉伸性能 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenTensileList = specimensData.numberOfTestSpecimenTensile ? specimensData.numberOfTestSpecimenTensile : []
                                        numberOfTestSpecimenTensileList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList})
                                    }} value={specimensData.numberOfTestSpecimenTensile?
                                        specimensData.numberOfTestSpecimenTensile[index + 1] ?? 0 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.tensileCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBendPerformance ${index + 2}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bend <br></br>Performance <br></br>彎曲表現 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenBendPerformanceList = specimensData.numberOfTestSpecimenBendPerformance ? specimensData.numberOfTestSpecimenBendPerformance : []
                                        numberOfTestSpecimenBendPerformanceList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList})
                                    }} value={specimensData.numberOfTestSpecimenBendPerformance ?
                                        specimensData.numberOfTestSpecimenBendPerformance[index + 1] ?? 0 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.bendCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBondProperty ${index + 2}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Bond Property<br></br> (Surface Geometry)<br></br> 粘結性能 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenBondPropertyList = specimensData.numberOfTestSpecimenBondProperty ? specimensData.numberOfTestSpecimenBondProperty : []
                                        numberOfTestSpecimenBondPropertyList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList})
                                    }} value={specimensData.numberOfTestSpecimenBondProperty ?
                                        specimensData.numberOfTestSpecimenBondProperty[index + 1] ?? 0 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.bondCount}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenChemicalComposition ${index + 2}`} xs={12} lg={3}>
                                    <Form.Label className="col-form-label col-form-label-sm">Chemical <br></br>Composition <br></br>化學分析 :</Form.Label>
                                    <Form.Control required type="number"
                                    onChange={e => {
                                        var numberOfTestSpecimenChemicalCompositionList = specimensData.numberOfTestSpecimenChemicalComposition ? specimensData.numberOfTestSpecimenChemicalComposition : []
                                        numberOfTestSpecimenChemicalCompositionList![index + 1] = Number(e.target.value)
                                        setSpecimens({...specimensData, numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList})
                                    }} value={specimensData.numberOfTestSpecimenChemicalComposition ?
                                        specimensData.numberOfTestSpecimenChemicalComposition[index + 1] ?? 0 
                                        : 0}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.chemicalCount}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Group>
                                
                        </Col>
                                    <p style={{fontSize:"12px", marginTop:"3rem"}}><b>Note : Please refer to table 10 of CS2 : 2012 for the no. of test specimen required relevant to the tonnage in the batch</b></p>
                        
                            </Row>
                        </Row>
                    </Container>
                        { <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        
                            {numberOfSpecimensstate !== 8 &&
                                <>
                                    {<Button variant="primary"
                                    onClick={e => {
                                        setCopyAndAdd(true);
                                        setLastNumberOfSpecimens(numberOfSpecimensstate);
                                        setNumberOfSpecimensstate(current=>current+1);
                                        setIndex(index + 1)
                                    }}>
                                    Copy and Add
                                    </Button>}
                                    <Button variant="primary"onClick={e => {
                                        setCopyAndAdd(false);
                                        setLastNumberOfSpecimens(numberOfSpecimensstate);
                                        setNumberOfSpecimensstate(current=>current+1);
                                        setIndex(index + 1)
                                    }}>
                                    Add
                                    </Button>
                                </>
                            }
                            <Button variant="primary"onClick={e => {
                                    setCopyAndAdd(false);

                                    var list : string[] | number[] = specimensData.id ?? [];
                                    var iDList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        iDList = list
                                    }
                                    else{
                                        iDList = list
                                    }

                                    list = specimensData.setNO ?? [];
                                    var setNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        setNOList = list
                                    }
                                    else{
                                        setNOList = list
                                    }
                                    
                                    list = specimensData.batchNO ?? [];
                                    var batchNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        batchNOList = list
                                    }
                                    else{
                                        batchNOList = list
                                    }

                                    list = specimensData.massInBatch ?? [];
                                    var massInBatchList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        massInBatchList = list
                                    }
                                    else{
                                        massInBatchList = list
                                    }


                                    list = specimensData.nominalSize ?? [];
                                    var nominalSizeList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        nominalSizeList = list
                                    }
                                    else{
                                        nominalSizeList = list
                                    }


                                    list = specimensData.grade ?? [];
                                    var gradeList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        gradeList = list
                                    }
                                    else{
                                        gradeList = list
                                    }

                                    
                                    list = specimensData.barPattern ?? [];
                                    var barPatternList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        barPatternList = list
                                    }
                                    else{
                                        barPatternList = list
                                    }


                                    list = specimensData.class ?? [];
                                    var classList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        classList = list
                                    }
                                    else{
                                        classList = list
                                    }


                                    list = specimensData.customerSampleIdentityNO ?? [];
                                    var customerSampleIdentityNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        customerSampleIdentityNOList = list
                                    }
                                    else{
                                        customerSampleIdentityNOList = list
                                    }

                                    list = specimensData.numberOfTestSpecimenTensile ?? [];
                                    var numberOfTestSpecimenTensileList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        numberOfTestSpecimenTensileList = list
                                    }
                                    else{
                                        numberOfTestSpecimenTensileList = list
                                    }

                                    list = specimensData.numberOfTestSpecimenBendPerformance ?? [];
                                    var numberOfTestSpecimenBendPerformanceList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        numberOfTestSpecimenBendPerformanceList = list
                                    }
                                    else{
                                        numberOfTestSpecimenBendPerformanceList = list
                                    }

                                    list = specimensData.numberOfTestSpecimenBondProperty ?? [];
                                    var numberOfTestSpecimenBondPropertyList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        numberOfTestSpecimenBondPropertyList = list
                                    }
                                    else{
                                        numberOfTestSpecimenBondPropertyList = list
                                    }

                                    list = specimensData.numberOfTestSpecimenChemicalComposition ?? [];
                                    var numberOfTestSpecimenChemicalCompositionList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        numberOfTestSpecimenChemicalCompositionList = list
                                    }
                                    else{
                                        numberOfTestSpecimenChemicalCompositionList = list
                                    }

                                    list = specimensData.customer ?? [];
                                    var customerList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        customerList = list
                                    }
                                    else{
                                        customerList = list
                                    }

                                    setSpecimens(
                                    {
                                        ...specimensData, 
                                        id: iDList,
                                        setNO: setNOList,
                                        batchNO: batchNOList,
                                        massInBatch: massInBatchList,
                                        nominalSize: nominalSizeList,
                                        grade: gradeList,
                                        barPattern: barPatternList,
                                        class: classList,
                                        customerSampleIdentityNO: customerSampleIdentityNOList,
                                        numberOfTestSpecimenTensile: numberOfTestSpecimenTensileList,
                                        numberOfTestSpecimenBendPerformance: numberOfTestSpecimenBendPerformanceList,
                                        numberOfTestSpecimenBondProperty: numberOfTestSpecimenBondPropertyList,
                                        numberOfTestSpecimenChemicalComposition: numberOfTestSpecimenChemicalCompositionList,
                                        customer: customerList
                                    })
                                    console.log(specimensData);
                                    setLastNumberOfSpecimens(numberOfSpecimensstate);
                                    setNumberOfSpecimensstate(current=>current-1);
                                    setIndex(index + 1)
                            }}>
                                Remove
                            </Button>
                        </div> }</React.Fragment>)}
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part III" title="Service" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3  m-0">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Express Testing Service 快速測試服務* :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxExpress">
                            <Form.Label>Request test service for <span className="text-danger">Express</span> / <span className="text-danger">Double Express</span> 要求 
                            <span className="text-danger"> 快速</span> / <span className="text-danger">特快</span> 測試服務</Form.Label>
                            {/* <br></br><Form.Label>Additional charge 額外收費 <span className="text-danger">30%</span> / <span className="text-danger">50%</span></Form.Label> */}
                            <br></br>
                            {steelBarFormData.expressOrNot === true && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="Yes 是" required defaultChecked
                            onClick={e => {setSteelBarForm({ ...steelBarFormData, expressOrNot: true, expressThirtyOrFifty: "30%"});
                                            handleClickOpen();
                            }}/>
                            }
                            {steelBarFormData.expressOrNot !== true && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="Yes 是" required
                            onClick={e => {setSteelBarForm({ ...steelBarFormData, expressOrNot: true, expressThirtyOrFifty: "30%"});
                                            handleClickOpen();
                            }}/>
                            }

                            {steelBarFormData.expressOrNot === false && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="No 否" required defaultChecked
                            onClick={e => setSteelBarForm({ ...steelBarFormData, expressOrNot: false, expressThirtyOrFifty: ""})}/>}
                            {steelBarFormData.expressOrNot !== false && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="No 否" required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, expressOrNot: false, expressThirtyOrFifty: ""})}/>}
                            
                            {steelBarFormData.expressOrNot === true &&
                            <>
                            <div className="mb-3"></div>
                            <Form.Select style={{ width: "18em"}} defaultValue={steelBarFormData.expressThirtyOrFifty} required onChange={e => setSteelBarForm({ ...steelBarFormData, expressThirtyOrFifty: e.target.value})}>
                              <option value="30%">Express (+30%)</option>
                              <option value="50%">Double Express (+50%)</option>
                            </Form.Select>
                            </>}
                        <br></br>
                        {/* <p style={{fontSize:"12px", marginTop:"1rem"}}><b>* - 30% or 50% Express test service charge depend on laboratory and customer completion date of agreement. </b></p>
                        <p style={{fontSize:"12px"}}><b>* - 30% 或 50% 快速測試服務費用取決於實驗室與客戶協議測試完成日期。</b></p> */}
                        <p style={{fontSize:"12px", marginTop:"1rem"}}><b>* - Express test service charge depend on laboratory and customer completion date of agreement. </b></p>
                        <p style={{fontSize:"12px"}}><b>* - 快速測試服務費用取決於實驗室與客戶協議測試完成日期。</b></p>
                        </Form.Group>

                        {/* <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Laboratory feedback 實驗室回覆 :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxSteel">
                            <Form.Label>Steel Laboratory  (Physical Test)</Form.Label>
                            <br></br>
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Accepted 接受" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, steelLaboratoryFeedback: "Accepted 接受"})}/>
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Rejected 否決" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, steelLaboratoryFeedback: "Rejected 否決"})}/>
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                <ImgUploadBox boxLabelEng="Upload signature photo or sign in box" boxLabelChin="上載簽名相片" dataAttribute="Steel" imgData={imgData} setImg={setImg}/>
                                <div style={{display:"flex", flexDirection:"column", width:"180px", borderStyle:"solid", borderWidth:"1px"}}>
                                    {imgData.signatureSteel ? imgData.SignatureDocTypeSteel?.includes("pdf") ? <embed src={SrcSignatureSteel}/> : <img width={"inherit"} alt="preview image" src={SrcSignatureSteel} /> : <></> }
                                    
                                </div>
                            </div>
                        </Form.Group>
                        <br></br>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxChemistry">
                            <Form.Label>Chemistry Laboratory  (Chemical Test)</Form.Label>
                            <br></br>
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Accepted 接受" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, chemistryLaboratoryFeedback: "Accepted 接受"})}/>
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Rejected 否決" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, chemistryLaboratoryFeedback: "Rejected 否決"})}/>
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                <ImgUploadBox boxLabelEng="Upload signature photo or sign in box" boxLabelChin="上載簽名相片" dataAttribute="Chemistry" imgData={imgData} setImg={setImg}/>
                                <div style={{display:"flex", flexDirection:"column", width:"180px", borderStyle:"solid", borderWidth:"1px"}}>
                                    {imgData.signatureChemistry ? imgData.SignatureDocTypeChemistry?.includes("pdf") ? <embed src={SrcSignatureChemistry}/> : <img width={"inherit"} alt="preview image" src={SrcSignatureChemistry} /> : <></> }
                                    
                                </div>
                            </div>
                        </Form.Group> */}
                    </Row>
                </div>
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3  m-0">
                        <Row className="mb-3">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Remark :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxConformity">
                            
                        <Form.Label style={{marginTop:"1rem"}}><b>If you request a statement of conformity to a specification or standard for the test report, Castco's decision rule will be applied. (If no selection of above, laboratory will apply no.2 or 3.)
                                                                        Detail please refer the "Castco Decision rules for statement of conformity on the test report" section of the quotation.
                                                                        </b></Form.Label>
                            <br></br>
                            {steelBarFormData.conformity === "1" &&
                            <Form.Check defaultChecked type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)" required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "1"})}/>}
                            {steelBarFormData.conformity !== "1" &&
                            <Form.Check type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)" required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "1"})}/>}
                            <br></br>

                            {steelBarFormData.conformity === "2" &&
                            <Form.Check defaultChecked type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)" required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "2"})}/>}
                            {steelBarFormData.conformity !== "2" &&
                            <Form.Check type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)" required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "2"})}/>}
                            <br></br>

                            {steelBarFormData.conformity === "3" &&
                            <Form.Check defaultChecked type="radio" name="radiogroupconformity" label="3. Statement of conformity not require." required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "3"})}/>}
                            {steelBarFormData.conformity !== "3" &&
                            <Form.Check type="radio" name="radiogroupconformity" label="3. Statement of conformity not require." required
                            onClick={e => setSteelBarForm({ ...steelBarFormData, conformity: "3"})}/>}
                            <br></br>
                        </Form.Group>
                        </Row>

                    </Row>
                </div>
                </Tab>
                {/* <Tab eventKey="Part IV" title="Part IV" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3  m-0">
                        <Row className="mb-3">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Remark :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxConformity">
                            
                        <Form.Label style={{marginTop:"1rem"}}><b>If you request a statement of conformity to a specification or standard for the test report, Castco's decision rule will be applied. (If no selection of above, laboratory will apply no.2 or 3.)
                                                                        Detail please refer the "Castco Decision rules for statement of conformity on the test report" section of the quotation.
                                                                        </b></Form.Label>
                            <br></br>
                            <Form.Check type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, conformity: "1"})}/><br></br>
                            <Form.Check type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)" required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, conformity: "2"})}/><br></br>
                            <Form.Check type="radio" name="radiogroupconformity" label="3. Statement of conformity not require." required
                            onChange={e => setSteelBarForm({ ...steelBarFormData, conformity: "3"})}/><br></br>
                        </Form.Group>
                        </Row>

                    </Row>
                </div>
                </Tab> */}
                <Tab eventKey="Part IV" title="Contact" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3  m-0">
                        <Row className="mb-3">
                        <Form.Label><b>如有問題 ，</b></Form.Label>
                            <Form.Group as={Col} controlId="formGridContactPerson" xs={12} lg={4}>
                            <Form.Label>請聯絡 Contact :</Form.Label>
                            <Form.Control required defaultValue={steelBarFormData.contactPerson}
                            onChange={e => setSteelBarForm({ ...steelBarFormData, contactPerson: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                {steelBarFormErrorMessages.contact}
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridTelNO" xs={12} lg={4}>
                            <Form.Label>電話號碼 Tel No. :</Form.Label>
                            <Form.Control type="number" required defaultValue={steelBarFormData.telNO}
                            onChange={e => setSteelBarForm({ ...steelBarFormData, telNO: Number(e.target.value)})}/>
                            <Form.Control.Feedback type="invalid">
                                {steelBarFormErrorMessages.telNo}
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridFaxNO" xs={12} lg={4}>
                            <Form.Label>傳真號碼 Fax No. :</Form.Label>
                            <Form.Control type="number" defaultValue={steelBarFormData.faxNO}
                            onChange={e => setSteelBarForm({ ...steelBarFormData, faxNO: Number(e.target.value)})}/>
                            <Form.Control.Feedback type="invalid">
                                {steelBarFormErrorMessages.faxNo}
                            </Form.Control.Feedback>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col} className="mb-3" controlId="formGridEmail" xs={12} lg={6}>
                                <Form.Label>測試結果發送至 電郵地址 Send the test results to : E-Mail :</Form.Label>
                                <Form.Control type="email" required defaultValue={steelBarFormData.email}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, email: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormData.email === "" || steelBarFormData.email === undefined || steelBarFormData.email === null ? 
                                        steelBarFormErrorMessages.emailEmpty
                                        : steelBarFormErrorMessages.emailWrongFormat}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} className="mb-3" controlId="formGridSendTo" xs={12} lg={6}>
                                <Form.Label>測試報告交予 Send the test report to :</Form.Label>
                                <Form.Control required defaultValue={steelBarFormData.sendTo}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, sendTo: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.sendTheTestReportTo}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group  as={Col} controlId="formBillTestingFeesTo" className="mb-3" xs={12} lg={4}>
                                <Form.Label><b>測試費用賬單交予 Bill the testing fees to :</b></Form.Label>
                                <Form.Control required defaultValue={steelBarFormData.billTo}
                                onChange={e => setSteelBarForm({ ...steelBarFormData, billTo: e.target.value})}/>
                                <Form.Control.Feedback type="invalid">
                                    {steelBarFormErrorMessages.billTheTestingFeeTo}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Form.Group>
                            {<Form.Group controlId="formFileChop" className="mb-3">
                                <Form.Label>Company Chop 公司蓋印</Form.Label>
                                <Form.Control style={{ width: 'auto' }} type="file" accept="image/*,.pdf" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setImg({...imgData, ChopGenre: "Signature", Chop: e.target.files![0], ChopDocType: e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]})}/>
                                <br></br>
                                {/* {imgData.Chop ? imgData.ChopDocType?.includes("pdf") ? <embed src={SrcChop}/> : <img width={"inherit"} alt="preview" src={SrcChop} /> : <></> } */}
                                {SrcChopNew ? type?.includes("pdf") ? <embed src={SrcChopNew}/> : <img width={"250px"} alt="N/A" src={SrcChopNew}/> : type === "" ? <></> : SrcChop ? type?.includes("pdf") ? <embed src={SrcChop}/> : <img width={"250px"} alt="N/A" src={`data:image/jpg;base64,${SrcChop}`}/> : <></> }
                            </Form.Group>}

                            {(localStorage.getItem("role") === "0" && status !== "0") && <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Customer's Signature 客戶代表簽署</Form.Label>
                                <img width={"250px"} alt="N/A" src={`data:image/jpg;base64,${SrcSign}`}/>
                            </div>}

                            {(localStorage.getItem("role") === "2" || localStorage.getItem("role") === "1" || status === "0") &&  <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Customer's Signature 客戶代表簽署</Form.Label>
                                <ImgUploadBox boxLabelEng="Upload signature photo or sign in box" boxLabelChin="上載簽名相片" dataAttribute="Signature" imgData={imgData} setImg={setImg}/>
                                <div style={{display:"flex", flexDirection:"column", width:"180px", borderStyle:"solid", borderWidth:"1px"}}>
                                    {SrcSignature ? <img width={"inherit"} alt="N/A" src={SrcSignature}/> : typeSign === "" && imgData.SignatureDocType !== undefined ? <></> : SrcSign ? <img width={"inherit"} alt="N/A" src={`data:image/jpg;base64,${SrcSign}`}/> : <></> }
                                    {/* {imgData.signature ? imgData.SignatureDocType?.includes("pdf") ? <embed src={SrcSignature}/> : <img width={"inherit"} alt="preview" src={SrcSignature} /> : <></> } */}
                                    {/* {imgData.signatureChemistry && <span style={{color:"blue"}}>
                                    Please ensure the photo is in correct direction
                                    </span> }
                                        {imgData.signatureChemistry && 
                                    <span style={{color:"blue"}}>
                                        請確保相片方向正確
                                    </span> } */}
                                </div>
                            </div> }
                        </Form.Group>
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part V" title="Report" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3  m-0">
                    <Container className="justify-content-md-center" style={{width: "95%"}}>
                        <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                            Set NO {numberOfTestReport}
                        </Row>
                        <Row className="bg-success bg-opacity-10 pt-3">
                            <Row className="mb-3">
                                <Form.Label><b>If need to show the information in the test report, please fill in the details</b></Form.Label>
                                <Form.Group as={Col} controlId = {`formGridDeliveryNoteNO ${numberOfTestReport}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Delivery Note No. 交貨單號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var deliveryNoteNOList = testReportData.deliveryNoteNO ? testReportData.deliveryNoteNO : []
                                        deliveryNoteNOList![numberOfTestReport - 1] = e.target.value
                                        setTestReport({...testReportData, deliveryNoteNO: deliveryNoteNOList})
                                    }}
                                    value={
                                    testReportData.deliveryNoteNO ?
                                    testReportData.deliveryNoteNO[numberOfTestReport - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.deliveryNoteNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridStockistCertNO ${numberOfTestReport}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Stockist Cert No. 供應商證書編號 :</Form.Label>
                                    <Form.Control
                                    //{imgData.StockistCert && imgData.StockistCert[numberOfTestReport - 1] !== undefined ? true : false}
                                    onChange={e => {
                                        var stockistCertNOList = testReportData.stockistCertNO ? testReportData.stockistCertNO : []
                                        stockistCertNOList![numberOfTestReport - 1] = e.target.value
                                        setTestReport({...testReportData, stockistCertNO: stockistCertNOList})
                                    }}
                                    value={
                                    testReportData.stockistCertNO ?
                                    testReportData.stockistCertNO[numberOfTestReport - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.stockistCertNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridLotNO ${numberOfTestReport}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Lot No. 批號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var lotNOList = testReportData.lotNO ? testReportData.lotNO : []
                                        lotNOList![numberOfTestReport - 1] = e.target.value
                                        setTestReport({...testReportData, lotNO: lotNOList})
                                    }}
                                    value={
                                    testReportData.lotNO ?
                                    testReportData.lotNO[numberOfTestReport - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.lotNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridMillCertNO ${numberOfTestReport}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Mill Cert No. 工廠證書編號 :</Form.Label>
                                    <Form.Control as="textarea" rows={2}
                                    //{imgData.MillCert && imgData.MillCert[numberOfTestReport - 1] !== undefined ? true : false} 
                                    onChange={e => {
                                        var millCertNOList = testReportData.millCertNO ? testReportData.millCertNO : []
                                        millCertNOList![numberOfTestReport - 1] = e.target.value
                                        setTestReport({...testReportData, millCertNO: millCertNOList})
                                    }}
                                    value={
                                    testReportData.millCertNO ?
                                    testReportData.millCertNO[numberOfTestReport - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.millCertNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridHeatNO ${numberOfTestReport}`} xs={12} md={12} lg={4}>
                                    <Form.Label>Heat No. 爐編號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var heatNOList = testReportData.heatNO ? testReportData.heatNO : []
                                        heatNOList![numberOfTestReport - 1] = e.target.value
                                        setTestReport({...testReportData, heatNO: heatNOList})
                                    }}
                                    value={
                                    testReportData.heatNO ?
                                    testReportData.heatNO[numberOfTestReport - 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.heatNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <div className="mb-3"></div>
                                
                                {/* <Form.Group as={Col} controlId = {`formFileStockistCert 1`} xs={12} md={6} lg={3}>
                                    <Form.Label>Stockist Cert 供應商證書 :</Form.Label><br></br>
                                    {SrcStockistCert.length >= 1 && SrcStockistCert[0] !== "" ?
                                    <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcStockistCert[0] + SrcStockistCertType[0]} href={SrcStockistCert[0]}> Stockist Cert Link</a>
                                    : <p>Empty</p>}
                                    <Form.Control //required={SrcStockistCert.length >= 1 && SrcStockistCert[0] !== "" ? false : true}
                                    required={steelBarFormData.testingAccordance === "CS2 : 2012"}
                                    //{testReportData.stockistCertNO && testReportData.stockistCertNO[numberOfTestReport - 1] !== "" 
                                    //    && testReportData.stockistCertNO[numberOfTestReport - 1] !== undefined  ? true : false} 
                                    type="file" accept=".zip,.pdf" 
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                    {
                                        var StockistCertGenreList = imgData.StockistCertGenre ? imgData.StockistCertGenre : []
                                        var StockistCertList = imgData.StockistCert ? imgData.StockistCert : []
                                        var StockistCertDocTypeList = imgData.StockistCertDocType ? imgData.StockistCertDocType : []
                                        StockistCertGenreList![numberOfTestReport - 1] = "StockistCert"
                                        StockistCertList![numberOfTestReport - 1] = e.target.files![0]
                                        StockistCertDocTypeList![numberOfTestReport - 1] = e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]
                                        setImg({...imgData
                                        , StockistCertGenre: StockistCertGenreList
                                        , StockistCert: StockistCertList
                                        , StockistCertDocType: StockistCertDocTypeList})
                                    }}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formFileMillCert 1`} xs={12} md={6} lg={3}>
                                    <Form.Label>Mill Cert 工廠證書 :</Form.Label><br></br>
                                    {SrcMillCert.length >= 1 && SrcMillCert[0] !== ""?
                                    <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcMillCert[0] + SrcMillCertType[0]} href={SrcMillCert[0]}> Mill Cert Link</a>
                                    : <p>Empty</p>}
                                    <Form.Control //required={SrcMillCert.length >= 1 && SrcMillCert[0] !== "" ? false : true}
                                    //{testReportData.millCertNO && testReportData.millCertNO[numberOfTestReport - 1] !== "" 
                                    //    && testReportData.millCertNO[numberOfTestReport - 1] !== undefined ? true : false} 
                                    type="file" accept=".zip,.pdf" 
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                    {
                                        var MillCertGenreList = imgData.MillCertGenre ? imgData.MillCertGenre : []
                                        var MillCertList = imgData.MillCert ? imgData.MillCert : []
                                        var MillCertDocTypeList = imgData.MillCertDocType ? imgData.MillCertDocType : []
                                        MillCertGenreList![numberOfTestReport - 1] = "MillCert"
                                        MillCertList![numberOfTestReport - 1] = e.target.files![0]
                                        MillCertDocTypeList![numberOfTestReport - 1] = e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]
                                        setImg({...imgData
                                        , MillCertGenre: MillCertGenreList
                                        , MillCert: MillCertList
                                        , MillCertDocType: MillCertDocTypeList})
                                    }}/>
                                </Form.Group> */}
                            </Row>
                        </Row>
                    </Container>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                            
                    {numberOfTestReportstate !== 8 &&
                        <>
                            { <Button variant="primary"
                            onClick={e => {
                                setCopyAndAddTestReport(true);
                                setLastNumberOfTestReport(numberOfTestReportstate);
                                setNumberOfTestReportstate(current=>current+1);
                                setIndex(0);
                            }}>
                            Copy and Add
                            </Button> }
                            <Button variant="primary"onClick={e => {
                                setCopyAndAddTestReport(false);
                                setLastNumberOfTestReport(numberOfTestReportstate);
                                setNumberOfTestReportstate(current=>current+1);
                                setIndex(0);
                            }}>
                            Add
                            </Button>
                        </>
                    }
                    {numberOfTestReportstate !== 1 &&
                    <Button variant="primary"onClick={e => {
                            setCopyAndAddTestReport(false);
                            var list : string[] | number[] = testReportData.id ?? [];
                            var iDList
                            list = list.filter((_, i) => i !== 0)
                            iDList= list

                            list = testReportData.setNO ?? [];
                            var setNOList
                            list = list.filter((_, i) => i !== 0)
                            setNOList = list

                            list = testReportData.deliveryNoteNO ?? []
                            var deliveryNoteNOList
                            list = list.filter((_, i) => i !== 0)
                            deliveryNoteNOList = list

                            list = testReportData.stockistCertNO ?? [];
                            var stockistCertNOList
                            list = list.filter((_, i) => i !== 0)
                            stockistCertNOList = list

                            list = testReportData.lotNO ?? [];
                            var lotNOList
                            list = list.filter((_, i) => i !== 0)
                            lotNOList = list

                            list = testReportData.millCertNO ?? [];
                            var millCertNOList
                            list = list.filter((_, i) => i !== 0)
                            millCertNOList = list

                            list = testReportData.heatNO ?? [];
                            var heatNOList
                            list = list.filter((_, i) => i !== 0)
                            heatNOList = list
                            
                            /* list = imgData.StockistCert ?? [];
                            var StockistCertList
                            const listStockistCertResult = list.filter((_, i) => i !== 0)
                            StockistCertList = listStockistCertResult

                            list = imgData.StockistCertGenre ?? [];
                            var StockistCertGenreList
                            list = list.filter((_, i) => i !== 0)
                            StockistCertGenreList = list

                            list = imgData.StockistCertDocType ?? [];
                            var StockistCertDocTypeList
                            list = list.filter((_, i) => i !== 0)
                            StockistCertDocTypeList = list
                            

                            list = imgData.MillCert ?? [];
                            var MillCertList
                            const listMillCertResult = list.filter((_, i) => i !== 0)
                            MillCertList = listMillCertResult

                            list = imgData.MillCertGenre ?? [];
                            var MillCertGenreList
                            list = list.filter((_, i) => i !== 0)
                            MillCertGenreList = list

                            list = imgData.MillCertDocType ?? [];
                            var MillCertDocTypeList
                            list = list.filter((_, i) => i !== 0)
                            MillCertDocTypeList = list */


                            setTestReport(
                            {
                                ...testReportData, 
                                deliveryNoteNO: deliveryNoteNOList,
                                stockistCertNO: stockistCertNOList,
                                lotNO: lotNOList,
                                millCertNO: millCertNOList,
                                heatNO: heatNOList,
                            })
                            console.log(testReportData);

                            /* setImg(
                            {
                                ...imgData, 
                                StockistCert: StockistCertList,
                                StockistCertGenre: StockistCertGenreList,
                                StockistCertDocType: StockistCertDocTypeList,
                                MillCert: MillCertList,
                                MillCertGenre: MillCertGenreList,
                                MillCertDocType: MillCertDocTypeList,
                            })
                            console.log(imgData); */

                            setLastNumberOfTestReport(numberOfTestReportstate);
                            setNumberOfTestReportstate(current=>current-1);
                            setIndex(1)
                    }}>
                        Remove
                    </Button>}
                </div>
                
                {testReportList.map((item: any, index: any)=><React.Fragment key={`formGridtestReport ${index + 2}`}>
                    <Container className="justify-content-md-center" style={{width: "95%"}}>
                        <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                            Set NO {index + 2}
                        </Row>
                        <Row className="bg-success bg-opacity-10 pt-3">
                            <Row className="mb-3">
                            <Form.Label><b>If need to show the information in the test report, please fill in the details</b></Form.Label>
                                <Form.Group as={Col} controlId = {`formGridDeliveryNoteNO ${index + 2}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Delivery Note No. 交貨單號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var deliveryNoteNOList = testReportData.deliveryNoteNO ? testReportData.deliveryNoteNO : []
                                        deliveryNoteNOList![index + 1] = e.target.value
                                        setTestReport({...testReportData, deliveryNoteNO: deliveryNoteNOList})
                                    }} defaultValue={testReportData.deliveryNoteNO ?
                                    testReportData.deliveryNoteNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.deliveryNoteNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridStockistCertNO ${index + 2}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Stockist Cert No. 供應商證書編號 :</Form.Label>
                                    <Form.Control
                                    //{imgData.StockistCert && imgData.StockistCert[index + 1] !== undefined ? true : false} 
                                    onChange={e => {
                                        var stockistCertNOList = testReportData.stockistCertNO ? testReportData.stockistCertNO : []
                                        stockistCertNOList![index + 1] = e.target.value
                                        setTestReport({...testReportData, stockistCertNO: stockistCertNOList})
                                    }} defaultValue={testReportData.stockistCertNO ?
                                    testReportData.stockistCertNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.stockistCertNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridLotNO ${index + 2}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Lot No. 批號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var lotNOList = testReportData.lotNO ? testReportData.lotNO : []
                                        lotNOList![index + 1] = e.target.value
                                        setTestReport({...testReportData, lotNO: lotNOList})
                                    }} defaultValue={testReportData.lotNO ?
                                    testReportData.lotNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.lotNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridMillCertNO ${index + 2}`} xs={12} md={6} lg={2}>
                                    <Form.Label>Mill Cert No. 工廠證書編號 :</Form.Label>
                                    <Form.Control as="textarea" rows={2}
                                    //{imgData.MillCert && imgData.MillCert[index + 1] !== undefined ? true : false} 
                                    onChange={e => {
                                        var millCertNOList = testReportData.millCertNO ? testReportData.millCertNO : []
                                        millCertNOList![index + 1] = e.target.value
                                        setTestReport({...testReportData, millCertNO: millCertNOList})
                                    }} defaultValue={testReportData.millCertNO ?
                                    testReportData.millCertNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.millCertNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formGridHeatNO ${index + 2}`} xs={12} md={12} lg={4}>
                                    <Form.Label>Heat No. 爐編號 :</Form.Label>
                                    <Form.Control 
                                    onChange={e => {
                                        var heatNOList = testReportData.heatNO ? testReportData.heatNO : []
                                        heatNOList![index + 1] = e.target.value
                                        setTestReport({...testReportData, heatNO: heatNOList})
                                    }} defaultValue={testReportData.heatNO ?
                                    testReportData.heatNO[index + 1] 
                                    : undefined}/>
                                    <Form.Control.Feedback type="invalid">
                                        {steelBarFormErrorMessages.heatNo}
                                    </Form.Control.Feedback>
                                </Form.Group>


                                
                                <div className="mb-3"></div>

                                {/* <Form.Group as={Col} controlId = {`formFileStockistCert ${index + 2}`} xs={12} md={6} lg={3}>
                                    <Form.Label>Stockist Cert 供應商證書 :</Form.Label><br></br>
                                    {SrcStockistCert.length >= index + 2 && SrcStockistCert[index + 1] !== "" ?
                                    <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcStockistCert[index + 1] + SrcStockistCertType[index + 1]} href={SrcStockistCert[index + 1]}> Stockist Cert Link</a>
                                    : <p>Empty</p>}
                                    <Form.Control //required={SrcStockistCert.length >= index + 2 && SrcStockistCert[index + 1] !== "" ? false : true}
                                    //{testReportData.stockistCertNO && testReportData.stockistCertNO[index + 1] !== "" 
                                    //    && testReportData.stockistCertNO[index + 1] !== undefined  ? true : false} 
                                    type="file" accept=".zip,.pdf" 
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                    {
                                        var StockistCertGenreList = imgData.StockistCertGenre ? imgData.StockistCertGenre : []
                                        var StockistCertList = imgData.StockistCert ? imgData.StockistCert : []
                                        var StockistCertDocTypeList = imgData.StockistCertDocType ? imgData.StockistCertDocType : []
                                        StockistCertGenreList![index + 1] = "StockistCert"
                                        StockistCertList![index + 1] = e.target.files![0]
                                        StockistCertDocTypeList![index + 1] = e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]
                                        setImg({...imgData
                                        , StockistCertGenre: StockistCertGenreList
                                        , StockistCert: StockistCertList
                                        , StockistCertDocType: StockistCertDocTypeList})
                                    }}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId = {`formFileMillCert ${index + 2}`} xs={12} md={6} lg={3}>
                                    <Form.Label>Mill Cert 工廠證書 :</Form.Label><br></br>
                                    {SrcMillCert.length >= index + 2 && SrcMillCert[index + 1] !== ""?
                                    <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcMillCert[index + 1] + SrcMillCertType[index + 1]} href={SrcMillCert[index + 1]}> Mill Cert Link</a>
                                    : <p>Empty</p>}
                                    <Form.Control //required={SrcMillCert.length >= index + 2 && SrcMillCert[index + 1] !== "" ? false : true}
                                    //{testReportData.millCertNO && testReportData.millCertNO[index + 1] !== "" 
                                    //    && testReportData.millCertNO[index + 1] !== undefined ? true : false} 
                                    type="file" accept=".zip,.pdf" 
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                    {
                                        var MillCertGenreList = imgData.MillCertGenre ? imgData.MillCertGenre : []
                                        var MillCertList = imgData.MillCert ? imgData.MillCert : []
                                        var MillCertDocTypeList = imgData.MillCertDocType ? imgData.MillCertDocType : []
                                        MillCertGenreList![index + 1] = "MillCert"
                                        MillCertList![index + 1] = e.target.files![0]
                                        MillCertDocTypeList![index + 1] = e.target.files!.length === 0 ? "":  e.target.files![0].type.split("/")[1]
                                        setImg({...imgData
                                        , MillCertGenre: MillCertGenreList
                                        , MillCert: MillCertList
                                        , MillCertDocType: MillCertDocTypeList})
                                    }}/>
                                </Form.Group> */}


                            </Row>

                        </Row>
                    </Container>
                        { <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        
                            {numberOfTestReportstate !== 8 &&
                                <>
                                    {<Button variant="primary"
                                    onClick={e => {
                                        setCopyAndAddTestReport(true);
                                        setLastNumberOfTestReport(numberOfTestReportstate);
                                        setNumberOfTestReportstate(current=>current+1);
                                    }}>
                                    Copy and Add
                                    </Button>}
                                    <Button variant="primary"onClick={e => {
                                        setCopyAndAddTestReport(false);
                                        setLastNumberOfTestReport(numberOfTestReportstate);
                                        setNumberOfTestReportstate(current=>current+1);
                                    }}>
                                    Add
                                    </Button>
                                </>
                            }
                            <Button variant="primary"onClick={e => {
                                    setCopyAndAddTestReport(false);

                                    var list : string[] | number[] = testReportData.id ?? [];
                                    var iDList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        iDList = list
                                    }
                                    else{
                                        iDList = list
                                    }

                                    list = testReportData.setNO ?? [];
                                    var setNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        setNOList = list
                                    }
                                    else{
                                        setNOList = list
                                    }

                                    list = testReportData.deliveryNoteNO ?? [];
                                    var deliveryNoteNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        deliveryNoteNOList = list
                                    }
                                    else{
                                        deliveryNoteNOList = list
                                    }

                                    list = testReportData.stockistCertNO ?? [];
                                    var stockistCertNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        stockistCertNOList = list
                                    }
                                    else{
                                        stockistCertNOList = list
                                    }

                                    list = testReportData.lotNO ?? [];
                                    var lotNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        lotNOList = list
                                    }
                                    else{
                                        lotNOList = list
                                    }

                                    list = testReportData.millCertNO ?? [];
                                    var millCertNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        millCertNOList = list
                                    }
                                    else{
                                        millCertNOList = list
                                    }

                                    list = testReportData.heatNO ?? [];
                                    var heatNOList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        heatNOList = list
                                    }
                                    else{
                                        heatNOList = list
                                    }
                                    
                                    /* list = imgData.StockistCert ?? [];
                                    var StockistCertList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        const listStockistCertResult = list.filter((_, i) => i !== index + 1);
                                        StockistCertList = listStockistCertResult
                                    }
                                    else{
                                        StockistCertList = list
                                    }

                                    list = imgData.StockistCertGenre ?? [];
                                    var StockistCertGenreList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        StockistCertGenreList = list
                                    }
                                    else{
                                        StockistCertGenreList = list
                                    }

                                    list = imgData.StockistCertDocType ?? [];
                                    var StockistCertDocTypeList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        StockistCertDocTypeList = list
                                    }
                                    else{
                                        StockistCertDocTypeList = list
                                    }
                                    

                                    list = imgData.MillCert ?? [];
                                    var MillCertList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        const listMillCertResult = list.filter((_, i) => i !== index + 1);
                                        MillCertList = listMillCertResult
                                    }
                                    else{
                                        MillCertList = list
                                    }

                                    list = imgData.MillCertGenre ?? [];
                                    var MillCertGenreList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        MillCertGenreList = list
                                    }
                                    else{
                                        MillCertGenreList = list
                                    }

                                    list = imgData.MillCertDocType ?? [];
                                    var MillCertDocTypeList
                                    if ((index + 1) === list.length - 1) { // Check if index is valid
                                        list = list.filter((_, i) => i !== index + 1);
                                        MillCertDocTypeList = list
                                    }
                                    else{
                                        MillCertDocTypeList = list
                                    } */



                                    setTestReport(
                                    {
                                        ...testReportData, 
                                        id: iDList,
                                        setNO: setNOList,
                                        deliveryNoteNO: deliveryNoteNOList,
                                        stockistCertNO: stockistCertNOList,
                                        lotNO: lotNOList,
                                        millCertNO: millCertNOList,
                                        heatNO: heatNOList,
                                    })
                                    console.log(testReportData);


                                    /* setImg(
                                    {
                                        ...imgData, 
                                        StockistCert: StockistCertList,
                                        StockistCertGenre: StockistCertGenreList,
                                        StockistCertDocType: StockistCertDocTypeList,
                                        MillCert: MillCertList,
                                        MillCertGenre: MillCertGenreList,
                                        MillCertDocType: MillCertDocTypeList,
                                    })
                                    console.log(imgData); */

                                    setLastNumberOfTestReport(numberOfTestReportstate);
                                    setNumberOfTestReportstate(current=>current-1);
                            }}>
                                Remove
                            </Button>
                        </div> }</React.Fragment>)}
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part VI" title="Remark" tabClassName="profile-tabitem">
                    <div className="profile-tab-space">
                        <Row className="bg-success bg-opacity-10 pt-3 m-0">
                            <Row className="mb-3">
                                <Form.Group as={Col} className="mb-3" controlId="formGridRemark"  xs={12} lg={12}>
                                    <Form.Label>Remark 備註 :</Form.Label>
                                    <Form.Control  as="textarea" rows={3} defaultValue={steelBarFormData.remark}
                                    onChange={e => setSteelBarForm({ ...steelBarFormData, remark: e.target.value})}/>
                                </Form.Group>
                            </Row>
                        </Row>
                    </div>
                </Tab>
                {(localStorage.getItem("role") === "2" || localStorage.getItem("role") === "1" || status === "0") && <Tab eventKey="save" title="Save" tabClassName="profile-tabitem" disabled={saving}/>}
                <Tab eventKey="submit" title={DynamicKeyTitle} tabClassName="profile-tabitem" disabled={submitting}/>
            </Tabs>
        </div>
    </Form>
    <Row className="mt-3 text-light  bg-success bg-opacity-75 p-3 fw-bold fs-3 m-0" style={{height: "25rem"}}>
       <Row className="fs-6">
        <Col xs={12} md={4}>
            Physical Test - <br></br>
            E-mail : steel@castco.com.hk <br></br>
            Attn : Ms. Winky Yiu <br></br>
            Direct Line : 2597 8273 <br></br>
            <br></br>
        </Col>
        <Col xs={12} md={12}>
            <Row>
                <Col xs={18} md={4}>香港新界粉嶺安居街33號</Col>
                <Col xs={18} md={4}>33, On Kui Street, Fanling, Hong Kong </Col>
                <Col xs={18} md={4}>Tel: (852) 2597 8333</Col>
            </Row>
            <br></br>
            <Row>
                <Col xs={18} md={4}>香港粉嶺安全街29A號</Col>
                <Col xs={18} md={4}>29A, On Chuen Street Fanling, Hong Kong</Col>
                <Col xs={18} md={4}>Fax: (852) 2597 8399</Col>
            </Row>
            <br></br>
            <Row>
                <Col xs={18} md={4}>Email: info@castco.com.hk</Col>
                <Col xs={18} md={4}>Website: www.castco.com.hk</Col>
                <Col xs={18} md={4}></Col>
            </Row>
        </Col>
      </Row>
    </Row>


    <SimpleDialog
        open={open}
        setOpen={setOpen}
        messagetype="express"
    />
      
    <SimpleDialog
        open={openSuccess}
        setOpen={setOpenSuccess}
        messagetype="success"
    />

    <SimpleDialog
        open={openSuccessEdit}
        setOpen={setOpenSuccessEdit}
        messagetype="successedit"
    />

    <SimpleDialog
        open={openSuccessSave}
        setOpen={setOpenSuccessSave}
        messagetype="successsave"
    />
    <SimpleDialogConfirm
        OpenConfirm={OpenConfirm}
        setOpenConfirm={setOpenConfirm}
        handleSubmit={handleSubmit}
        descCn={
            localStorage.getItem("role") === "0" ? 
                <>
                    { status === "0" ? "確定創建表格?" : "確定修改表格?"}
                    <br/>
                </>
                : null
        }
        descEn={
            localStorage.getItem("role") === "0" ? 
                <>
                    { status === "0" ? "Confirm to create the form?" : "Confirm to update the form?"}
                </>
                : null
        }
    />

    </Container>
    );
  };
  
  export default SteelBarFormEdit;
  